<template>
  <div
    class="h-[100%] rounded-[12px] pl-[20px] pr-[20px] pt-[10px] mt-[14px]"
    id="room-detail"
  >
    <div class="">
      <div class="flex cursor-pointer">
        <div class="flex justify-center items-center mr-[8px]">
          <svg
            width="7"
            height="12"
            viewBox="0 0 7 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M0.338101 5.99962C0.338101 5.88552 0.357334 5.77495 0.3958 5.6679C0.434267 5.56085 0.500293 5.46053 0.593876 5.36695L5.10348 0.857324C5.24834 0.712458 5.42142 0.642591 5.6227 0.647724C5.82398 0.652841 5.99706 0.727841 6.14193 0.872724C6.28679 1.01759 6.35923 1.19322 6.35923 1.39962C6.35923 1.60602 6.28679 1.78166 6.14193 1.92652L2.06883 5.99962L6.1573 10.0881C6.30217 10.233 6.37204 10.406 6.36693 10.6073C6.36179 10.8086 6.28679 10.9817 6.14193 11.1265C5.99706 11.2714 5.82142 11.3438 5.615 11.3438C5.4086 11.3438 5.23297 11.2714 5.0881 11.1265L0.593876 6.6323C0.500293 6.53872 0.434267 6.44 0.3958 6.33615C0.357334 6.23232 0.338101 6.12014 0.338101 5.99962Z"
              fill="#8396A6"
            />
          </svg>
        </div>
        <div
          class="flex justify-center items-center text-[#8396A6] cursor-pointer"
          @click="routeTo('/payment')"
        >
          ย้อนกลับ
        </div>
      </div>
    </div>
    <div class="flex mt-[14px]">
      <div
        class="bg-[#003765] h-[147px] w-[404px] rounded-[22px] p-[14px] text-[white]"
      >
        <div class="flex items-center">
          <div v-if="userProfileImage && userProfileImage !== ''">
            <img
              class="w-[114px] h-[114px] bg-slate-400 rounded-[22px]"
              :src="userProfileImage"
            />
          </div>
          <div v-else>
            <div class="w-[114px] h-[114px] rounded-[22px]">
              <svg
                width="100"
                height="100"
                viewBox="0 0 114 114"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clip-path="url(#clip0_721_16400)">
                  <rect
                    x="0.332031"
                    width="100%"
                    height="100%"
                    rx="16"
                    fill="#003765"
                  />
                  <path
                    d="M31.4771 106.798L29.2152 103.539H26.7175V106.798H24V95.1099H29.0769C32.2093 95.1099 34.1701 96.7309 34.1701 99.3489C34.1701 101.1 33.2833 102.388 31.7537 103.037L34.3817 106.798H31.4689H31.4771ZM28.9305 97.3145H26.7175V101.391H28.9305C30.5902 101.391 31.4283 100.621 31.4283 99.357C31.4283 98.0926 30.5902 97.3226 28.9305 97.3226V97.3145Z"
                    fill="white"
                  />
                  <path
                    d="M45.4044 104.625V106.798H36.3164V95.1099H45.1847V97.2821H39.0176V99.819H44.4688V101.926H39.0176V104.634H45.4044V104.625Z"
                    fill="white"
                  />
                  <path
                    d="M46.6527 105.647L47.572 103.612C48.5646 104.334 50.0373 104.828 51.4448 104.828C53.0558 104.828 53.7067 104.293 53.7067 103.572C53.7067 101.383 46.8805 102.891 46.8805 98.5465C46.8805 96.5607 48.4914 94.9072 51.8272 94.9072C53.2999 94.9072 54.8132 95.2558 55.9034 95.9447L55.0654 97.9953C53.9752 97.3793 52.8524 97.0794 51.811 97.0794C50.2 97.0794 49.5817 97.6792 49.5817 98.4168C49.5817 100.573 56.3997 99.0814 56.3997 103.377C56.3997 105.331 54.7725 107 51.4204 107C49.5573 107 47.686 106.449 46.6445 105.647H46.6527Z"
                    fill="white"
                  />
                  <path
                    d="M70.9462 100.767H73.4277V105.509C72.1341 106.481 70.3604 106.992 68.6844 106.992C64.9987 106.992 62.2812 104.471 62.2812 100.945C62.2812 97.4197 64.9987 94.8989 68.7332 94.8989C70.7916 94.8989 72.5083 95.6041 73.6474 96.9171L71.9062 98.522C71.052 97.6223 70.0594 97.2008 68.8715 97.2008C66.5934 97.2008 65.0312 98.7165 65.0312 100.937C65.0312 103.158 66.5934 104.674 68.8389 104.674C69.5793 104.674 70.2628 104.544 70.9543 104.171V100.751L70.9462 100.767Z"
                    fill="white"
                  />
                  <path
                    d="M75.8438 101.659V95.1099H78.5612V101.554C78.5612 103.774 79.5294 104.69 81.1729 104.69C82.8164 104.69 83.7846 103.774 83.7846 101.554V95.1099H86.4695V101.659C86.4695 105.096 84.4924 107 81.1566 107C77.8208 107 75.8438 105.096 75.8438 101.659Z"
                    fill="white"
                  />
                  <path
                    d="M96.6294 106.798L94.3676 103.539H91.8698V106.798H89.1523V95.1099H94.2293C97.3617 95.1099 99.3225 96.7309 99.3225 99.3489C99.3225 101.1 98.4356 102.388 96.906 103.037L99.534 106.798H96.6213H96.6294ZM94.0828 97.3145H91.8698V101.391H94.0828C95.7426 101.391 96.5806 100.621 96.5806 99.357C96.5806 98.0926 95.7426 97.3226 94.0828 97.3226V97.3145Z"
                    fill="white"
                  />
                  <path
                    d="M101.375 101.659V95.1099H104.092V101.554C104.092 103.774 105.061 104.69 106.704 104.69C108.348 104.69 109.316 103.774 109.316 101.554V95.1099H112.001V101.659C112.001 105.096 110.024 107 106.688 107C103.352 107 101.375 105.096 101.375 101.659Z"
                    fill="white"
                  />
                  <path
                    d="M91.6191 79.9444L81.0503 64.8443C87.1768 62.2182 90.7485 57.0551 90.7485 50.0117C90.7485 39.4748 82.8647 32.9663 70.2618 32.9663H63.875C65.372 35.0169 66.2589 37.5377 66.2589 40.261C66.2589 40.7879 66.2263 41.3147 66.1531 41.8254H69.6516C76.3232 41.8254 79.6916 44.8486 79.6916 50.0117C79.6916 55.1747 76.3151 58.198 69.6516 58.198H65.1768V66.8625H70.7988L79.8868 79.9444L81.4978 82.2706H93.23L91.6028 79.9444H91.6191Z"
                    fill="white"
                  />
                  <path
                    d="M63.3545 40.2613C63.3545 34.5957 58.7413 30 53.0542 30C47.3671 30 42.7539 34.5957 42.7539 40.2613C42.7539 44.6462 45.5283 48.3827 49.4174 49.8498V82.2627H62.2724V73.6063H56.6829V66.8546H62.2724V58.1982H56.6829V49.8498C60.572 48.3827 63.3464 44.6543 63.3464 40.2613H63.3545ZM53.0542 39.4832C51.5328 39.4832 50.3042 38.2593 50.3042 36.7436C50.3042 35.2279 51.5328 34.004 53.0542 34.004C54.5757 34.004 55.8042 35.2279 55.8042 36.7436C55.8042 38.2593 54.5757 39.4832 53.0542 39.4832Z"
                    fill="#F4D55E"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_721_16400">
                    <rect
                      width="100%"
                      height="100%"
                      fill="white"
                      transform="translate(0.332031)"
                    />
                  </clipPath>
                </defs>
              </svg>
            </div>
          </div>
          <div class="ml-[8px] flex flex-col justify-between h-[100%]">
            <div class="flex items-center">
              <div>
                <svg
                  width="30"
                  height="30"
                  viewBox="0 0 30 30"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <mask
                    id="mask0_1318_18103"
                    style="mask-type: alpha"
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="30"
                    height="30"
                  >
                    <rect width="30" height="30" fill="#D9D9D9" />
                  </mask>
                  <g mask="url(#mask0_1318_18103)">
                    <path
                      d="M3.125 25.6245V11.5621L12.5 4.50684L18.3533 8.92024C17.9767 8.99074 17.6233 9.09651 17.2932 9.23755C16.9631 9.37858 16.6458 9.55886 16.3413 9.7784L12.5 6.85052L4.99997 12.4996V23.7496H10.0721V25.6245H3.125ZM12.8125 25.6245V23.6074C12.8125 23.2358 12.9099 22.8894 13.1046 22.5681C13.2993 22.2467 13.5561 21.9875 13.875 21.7904C14.8093 21.2359 15.7904 20.8189 16.8185 20.5392C17.8465 20.2596 18.907 20.1197 20 20.1197C21.0929 20.1197 22.1534 20.2596 23.1814 20.5392C24.2095 20.8189 25.1907 21.2359 26.125 21.7904C26.4439 21.9875 26.7007 22.2467 26.8954 22.5681C27.0901 22.8894 27.1874 23.2358 27.1874 23.6074V25.6245H12.8125ZM14.8028 23.7496H25.1971V23.413C24.4038 22.9563 23.5709 22.6057 22.6983 22.3613C21.8257 22.1169 20.9263 21.9947 20 21.9947C19.0737 21.9947 18.1742 22.1169 17.3016 22.3613C16.429 22.6057 15.5961 22.9563 14.8028 23.413V23.7496ZM20.0014 18.1846C19.0469 18.1846 18.2352 17.8506 17.5661 17.1824C16.897 16.5143 16.5625 15.703 16.5625 14.7486C16.5625 13.7941 16.8966 12.9823 17.5647 12.3132C18.2328 11.6442 19.0441 11.3096 19.9986 11.3096C20.953 11.3096 21.7648 11.6437 22.4338 12.3118C23.1029 12.98 23.4374 13.7913 23.4374 14.7457C23.4374 15.7002 23.1034 16.5119 22.4353 17.181C21.7671 17.8501 20.9558 18.1846 20.0014 18.1846ZM20 16.3096C20.4343 16.3096 20.8033 16.1578 21.107 15.8541C21.4107 15.5504 21.5625 15.1814 21.5625 14.7471C21.5625 14.3128 21.4107 13.9438 21.107 13.6401C20.8033 13.3365 20.4343 13.1846 20 13.1846C19.5657 13.1846 19.1967 13.3365 18.893 13.6401C18.5893 13.9438 18.4374 14.3128 18.4374 14.7471C18.4374 15.1814 18.5893 15.5504 18.893 15.8541C19.1967 16.1578 19.5657 16.3096 20 16.3096Z"
                      fill="white"
                    />
                  </g>
                </svg>
              </div>
              <div class="ml-[4px]">
                {{ roomDetail?.data?.attributes?.RoomNumber }}
              </div>
            </div>
            <div class="text-[16px] mt-[4px]">
              {{
                userProfile.firstName
                  ? userProfile.firstName
                  : "ยังไม่มีผู้เข้าพัก"
              }}
              {{ userProfile.lastName }}
            </div>
            <div class="text-[12px] text-[#B9CCDC] mt-[4px]">
              เข้าพักเมื่อวันที่:
              {{
                contractProfile?.data
                  ? contractProfile.data.attributes.checkInDate
                  : "N/A"
              }}
            </div>
            <div class="text-[12px] text-[#B9CCDC]">
              ประเภทห้อง:
              {{
                roomDetail?.data?.attributes?.room_type?.data?.attributes
                  ?.roomTypeName
              }}
            </div>
          </div>
        </div>
      </div>
      <div
        class="bg-[#D44769] h-[147px] w-[339px] rounded-[22px] p-[14px] text-[white] ml-[14px]"
      >
        <div class="flex flex-col justify-between h-[100%]">
          <div class="font-bold text-[16px]">ยอดค้างชำระ</div>

          <div>
            <div class="text-[12px]">คงเหลือ</div>
            <div class="flex justify-between">
              <div class="text-[28px] font-bold flex items-center">
                {{ this.userPayRemain.toLocaleString('th-TH', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }} บาท
              </div>
              <!-- <div class="flex pt-[4px] pb-[4px] pl-[12px] pr-[12px] border rounded-[12px]  ">
                                <div>
                                    <svg width="22" height="23" viewBox="0 0 22 23" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <mask id="mask0_3440_6436" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0"
                                            y="0" width="22" height="23">
                                            <rect y="0.5" width="22" height="22" fill="#D9D9D9" />
                                        </mask>
                                        <g mask="url(#mask0_3440_6436)">
                                            <path
                                                d="M11.0104 19.2913C9.92874 19.2913 8.9156 19.0868 7.97096 18.6778C7.02632 18.2688 6.20261 17.713 5.49983 17.0102C4.79705 16.3074 4.24118 15.4838 3.83221 14.5393C3.42324 13.5947 3.21875 12.5817 3.21875 11.5002C3.21875 10.4186 3.42324 9.40543 3.83221 8.46056C4.24118 7.51569 4.79705 6.69187 5.49983 5.98909C6.20261 5.28633 7.02632 4.73046 7.97096 4.32149C8.9156 3.9125 9.92874 3.70801 11.0104 3.70801C12.1633 3.70801 13.2586 3.9504 14.2963 4.43518C15.334 4.91996 16.2248 5.60128 16.9687 6.47916V4.99485C16.9687 4.80006 17.0346 4.63677 17.1664 4.505C17.2983 4.37323 17.4616 4.30735 17.6565 4.30735C17.8513 4.30735 18.0146 4.37323 18.1462 4.505C18.2779 4.63677 18.3437 4.80006 18.3437 4.99485V8.13262C18.3437 8.36736 18.2643 8.56413 18.1055 8.72293C17.9466 8.88174 17.7499 8.96115 17.5151 8.96115H14.3774C14.1826 8.96115 14.0193 8.89523 13.8875 8.7634C13.7557 8.63157 13.6899 8.46822 13.6899 8.27335C13.6899 8.07847 13.7557 7.91522 13.8875 7.7836C14.0193 7.65198 14.1826 7.58617 14.3774 7.58617H16.0873C15.455 6.80701 14.7011 6.19502 13.8256 5.7502C12.9501 5.30539 12.0117 5.08299 11.0104 5.08299C9.22289 5.08299 7.70657 5.70555 6.46144 6.95069C5.2163 8.19583 4.59373 9.71215 4.59373 11.4997C4.59373 13.2872 5.2163 14.8035 6.46144 16.0486C7.70657 17.2937 9.22289 17.9163 11.0104 17.9163C12.4912 17.9163 13.8089 17.4618 14.9635 16.5528C16.1182 15.6438 16.87 14.4812 17.219 13.065C17.2778 12.8735 17.3815 12.7283 17.5302 12.6296C17.6788 12.5309 17.8469 12.4939 18.0344 12.5186C18.2335 12.5432 18.3875 12.632 18.4962 12.7847C18.6049 12.9375 18.6345 13.105 18.5852 13.2871C18.1892 15.0405 17.2884 16.4796 15.8828 17.6043C14.4773 18.729 12.8531 19.2913 11.0104 19.2913ZM11.6979 11.2211L14.2187 13.742C14.3456 13.8689 14.4106 14.0284 14.4135 14.2206C14.4164 14.4127 14.3515 14.5752 14.2187 14.708C14.0859 14.8408 13.9249 14.9072 13.7357 14.9072C13.5465 14.9072 13.3855 14.8408 13.2527 14.708L10.5714 12.0267C10.4857 11.9409 10.4228 11.8475 10.3828 11.7463C10.3429 11.6451 10.3229 11.5406 10.3229 11.4327V7.6038C10.3229 7.40902 10.3888 7.24575 10.5206 7.11398C10.6525 6.9822 10.8158 6.91632 11.0107 6.91632C11.2056 6.91632 11.3688 6.9822 11.5004 7.11398C11.6321 7.24575 11.6979 7.40902 11.6979 7.6038V11.2211Z"
                                                fill="white" />
                                        </g>
                                    </svg>
                                </div>
                                <div class="flex items-center ml-[4px]">ดูประวัติการใช้จ่าย</div>
                            </div> -->
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="mt-[14px] bg-[white] rounded-[12px] p-[24px]">
      <div class="font-bold text-[18px]">ประวัติการจ่ายค่าเช่า</div>
      <div class="flex">
        <div
          class="flex justify-start items-center rounded-[12px] mt-[14px] col-md-6"
        >
          <div class="bg-[#F3F7FA] rounded-[12px]">
            <div class="flex justify-start items-center">
              <div
                @click="tab = 1"
                class="cursor-pointer"
                :class="
                  tab == 1
                    ? 'bg-[#003765] pl-[9px] pr-[9px] pt-[8px] pb-[8px] rounded-[12px] text-[white]'
                    : 'text-[#003765] pl-[9px] pr-[9px] pt-[8px] pb-[8px] flex justify-center items-center'
                "
              >
                <div class="flex">
                  <div>
                    <svg
                      width="22"
                      height="23"
                      viewBox="0 0 22 23"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <mask
                        id="mask0_3440_9673"
                        style="mask-type: alpha"
                        maskUnits="userSpaceOnUse"
                        x="0"
                        y="0"
                        width="22"
                        height="23"
                      >
                        <rect y="0.5" width="22" height="22" fill="#D9D9D9" />
                      </mask>
                      <g mask="url(#mask0_3440_9673)">
                        <path
                          d="M17.4594 16.6629V18.2601C17.4594 18.3705 17.4994 18.4657 17.5793 18.5456C17.6592 18.6255 17.7544 18.6655 17.8649 18.6655C17.9753 18.6655 18.0705 18.6255 18.1504 18.5456C18.2303 18.4657 18.2703 18.3705 18.2703 18.2601V15.6952C18.2703 15.5847 18.2289 15.488 18.146 15.4052C18.0632 15.3223 17.9665 15.2809 17.8561 15.2809H15.2912C15.1807 15.2809 15.0855 15.3209 15.0056 15.4008C14.9257 15.4807 14.8857 15.5759 14.8857 15.6864C14.8857 15.7968 14.9257 15.892 15.0056 15.9719C15.0855 16.0518 15.1807 16.0918 15.2912 16.0918H16.8883L14.7306 18.2495C14.6507 18.3294 14.6092 18.4231 14.6063 18.5306C14.6034 18.6382 14.6448 18.7348 14.7306 18.8206C14.8105 18.9005 14.9057 18.9405 15.0162 18.9405C15.1266 18.9405 15.2218 18.9005 15.3017 18.8206L17.4594 16.6629ZM4.86409 19.2913C4.40693 19.2913 4.01647 19.1294 3.6927 18.8056C3.36892 18.4819 3.20703 18.0914 3.20703 17.6342V5.36507C3.20703 4.90791 3.36892 4.51745 3.6927 4.19368C4.01647 3.8699 4.40693 3.70801 4.86409 3.70801H17.1333C17.5904 3.70801 17.9809 3.8699 18.3046 4.19368C18.6284 4.51745 18.7903 4.90791 18.7903 5.36507V11.1629C18.5647 11.0666 18.3387 10.9849 18.1125 10.9179C17.8863 10.8509 17.6539 10.7975 17.4153 10.7575V5.36507C17.4153 5.29454 17.386 5.2299 17.3272 5.17112C17.2684 5.11236 17.2038 5.08298 17.1333 5.08298H4.86409C4.79357 5.08298 4.72892 5.11236 4.67015 5.17112C4.61139 5.2299 4.58201 5.29454 4.58201 5.36507V17.6342C4.58201 17.7048 4.61139 17.7694 4.67015 17.8282C4.72892 17.8869 4.79357 17.9163 4.86409 17.9163H10.2336C10.2677 18.1702 10.3182 18.4102 10.3852 18.6364C10.4522 18.8626 10.5339 19.0809 10.6302 19.2913H4.86409ZM4.58201 17.9163V5.08298V10.7575V10.6888V17.9163ZM6.64453 15.0605C6.64453 15.2556 6.71034 15.419 6.84196 15.5506C6.97358 15.6822 7.13693 15.748 7.33201 15.748H10.3271C10.367 15.5095 10.4264 15.2771 10.5051 15.0508C10.5838 14.8246 10.6696 14.5987 10.7625 14.3731H7.33201C7.13693 14.3731 6.97358 14.4389 6.84196 14.5705C6.71034 14.7021 6.64453 14.8655 6.64453 15.0605ZM6.64453 11.4997C6.64453 11.6947 6.71034 11.8581 6.84196 11.9897C6.97358 12.1213 7.13693 12.1871 7.33201 12.1871H12.4566C12.8514 11.8522 13.2727 11.5716 13.7205 11.3454C14.1682 11.1192 14.6477 10.9585 15.1589 10.8633C15.0567 10.8386 14.9421 10.8239 14.8151 10.8192C14.6882 10.8145 14.5737 10.8122 14.4714 10.8122H7.33201C7.13693 10.8122 6.97358 10.878 6.84196 11.0096C6.71034 11.1412 6.64453 11.3046 6.64453 11.4997ZM6.64453 7.93877C6.64453 8.13385 6.71034 8.2972 6.84196 8.42882C6.97358 8.56044 7.13693 8.62625 7.33201 8.62625H14.6653C14.8604 8.62625 15.0238 8.56044 15.1554 8.42882C15.287 8.2972 15.3528 8.13385 15.3528 7.93877C15.3528 7.74369 15.287 7.58034 15.1554 7.44872C15.0238 7.31708 14.8604 7.25127 14.6653 7.25127H7.33201C7.13693 7.25127 6.97358 7.31708 6.84196 7.44872C6.71034 7.58034 6.64453 7.74369 6.64453 7.93877ZM16.4987 21.1775C15.354 21.1775 14.3804 20.7762 13.5777 19.9735C12.775 19.1708 12.3737 18.1972 12.3737 17.0525C12.3737 15.9079 12.775 14.9342 13.5777 14.1316C14.3804 13.3289 15.354 12.9276 16.4987 12.9276C17.6433 12.9276 18.617 13.3289 19.4197 14.1316C20.2223 14.9342 20.6237 15.9079 20.6237 17.0525C20.6237 18.1972 20.2223 19.1708 19.4197 19.9735C18.617 20.7762 17.6433 21.1775 16.4987 21.1775Z"
                          :fill="tab == 1 ? 'white' : '#003765'"
                        />
                      </g>
                    </svg>
                  </div>
                  <div class="ml-[4px] flex items-center">ใบแจ้งหนี้</div>
                </div>
              </div>
              <div
                @click="tab = 3"
                class="cursor-pointer"
                :class="
                  tab == 3
                    ? 'bg-[#003765] pl-[9px] pr-[9px] pt-[8px] pb-[8px] rounded-[12px] text-[white]'
                    : 'text-[#003765] pl-[9px] pr-[9px] pt-[8px] pb-[8px] flex justify-center items-center'
                "
              >
                <div class="flex">
                  <div>
                    <svg
                      width="22"
                      height="23"
                      viewBox="0 0 22 23"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <mask
                        id="mask0_3440_6436"
                        style="mask-type: alpha"
                        maskUnits="userSpaceOnUse"
                        x="0"
                        y="0"
                        width="22"
                        height="23"
                      >
                        <rect y="0.5" width="22" height="22" fill="#D9D9D9" />
                      </mask>
                      <g mask="url(#mask0_3440_6436)">
                        <path
                          d="M11.0104 19.2913C9.92874 19.2913 8.9156 19.0868 7.97096 18.6778C7.02632 18.2688 6.20261 17.713 5.49983 17.0102C4.79705 16.3074 4.24118 15.4838 3.83221 14.5393C3.42324 13.5947 3.21875 12.5817 3.21875 11.5002C3.21875 10.4186 3.42324 9.40543 3.83221 8.46056C4.24118 7.51569 4.79705 6.69187 5.49983 5.98909C6.20261 5.28633 7.02632 4.73046 7.97096 4.32149C8.9156 3.9125 9.92874 3.70801 11.0104 3.70801C12.1633 3.70801 13.2586 3.9504 14.2963 4.43518C15.334 4.91996 16.2248 5.60128 16.9687 6.47916V4.99485C16.9687 4.80006 17.0346 4.63677 17.1664 4.505C17.2983 4.37323 17.4616 4.30735 17.6565 4.30735C17.8513 4.30735 18.0146 4.37323 18.1462 4.505C18.2779 4.63677 18.3437 4.80006 18.3437 4.99485V8.13262C18.3437 8.36736 18.2643 8.56413 18.1055 8.72293C17.9466 8.88174 17.7499 8.96115 17.5151 8.96115H14.3774C14.1826 8.96115 14.0193 8.89523 13.8875 8.7634C13.7557 8.63157 13.6899 8.46822 13.6899 8.27335C13.6899 8.07847 13.7557 7.91522 13.8875 7.7836C14.0193 7.65198 14.1826 7.58617 14.3774 7.58617H16.0873C15.455 6.80701 14.7011 6.19502 13.8256 5.7502C12.9501 5.30539 12.0117 5.08299 11.0104 5.08299C9.22289 5.08299 7.70657 5.70555 6.46144 6.95069C5.2163 8.19583 4.59373 9.71215 4.59373 11.4997C4.59373 13.2872 5.2163 14.8035 6.46144 16.0486C7.70657 17.2937 9.22289 17.9163 11.0104 17.9163C12.4912 17.9163 13.8089 17.4618 14.9635 16.5528C16.1182 15.6438 16.87 14.4812 17.219 13.065C17.2778 12.8735 17.3815 12.7283 17.5302 12.6296C17.6788 12.5309 17.8469 12.4939 18.0344 12.5186C18.2335 12.5432 18.3875 12.632 18.4962 12.7847C18.6049 12.9375 18.6345 13.105 18.5852 13.2871C18.1892 15.0405 17.2884 16.4796 15.8828 17.6043C14.4773 18.729 12.8531 19.2913 11.0104 19.2913ZM11.6979 11.2211L14.2187 13.742C14.3456 13.8689 14.4106 14.0284 14.4135 14.2206C14.4164 14.4127 14.3515 14.5752 14.2187 14.708C14.0859 14.8408 13.9249 14.9072 13.7357 14.9072C13.5465 14.9072 13.3855 14.8408 13.2527 14.708L10.5714 12.0267C10.4857 11.9409 10.4228 11.8475 10.3828 11.7463C10.3429 11.6451 10.3229 11.5406 10.3229 11.4327V7.6038C10.3229 7.40902 10.3888 7.24575 10.5206 7.11398C10.6525 6.9822 10.8158 6.91632 11.0107 6.91632C11.2056 6.91632 11.3688 6.9822 11.5004 7.11398C11.6321 7.24575 11.6979 7.40902 11.6979 7.6038V11.2211Z"
                          :fill="tab == 3 ? 'white' : '#003765'"
                        />
                      </g>
                    </svg>
                  </div>
                  <div class="ml-[4px] flex items-center">
                    หลักฐานและประวัติการชำระเงิน
                  </div>
                </div>
              </div>
              <div
                @click="tab = 2"
                class="cursor-pointer"
                :class="
                  tab == 2
                    ? 'bg-[#003765] pl-[9px] pr-[9px] pt-[8px] pb-[8px] rounded-[12px] text-[white]'
                    : 'text-[#003765] pl-[9px] pr-[9px] pt-[8px] pb-[8px] flex justify-center items-center'
                "
              >
                <div class="flex">
                  <div>
                    <svg
                      width="22"
                      height="23"
                      viewBox="0 0 22 23"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <mask
                        id="mask0_3440_16537"
                        style="mask-type: alpha"
                        maskUnits="userSpaceOnUse"
                        x="0"
                        y="0"
                        width="22"
                        height="23"
                      >
                        <rect y="0.5" width="22" height="22" fill="#D9D9D9" />
                      </mask>
                      <g mask="url(#mask0_3440_16537)">
                        <path
                          d="M5.49867 20.2087C4.8582 20.2087 4.31614 19.9869 3.87249 19.5433C3.42885 19.0996 3.20703 18.5575 3.20703 17.9171V16.454C3.20703 16.2192 3.28644 16.0224 3.44525 15.8636C3.60405 15.7048 3.80082 15.6254 4.03556 15.6254H5.95703V3.61535C5.95703 3.4661 6.02255 3.36885 6.15359 3.3236C6.28462 3.27836 6.41125 3.31686 6.53348 3.43908L7.22627 4.13185L8.21806 3.15565C8.3043 3.07076 8.40319 3.02832 8.51471 3.02832C8.62626 3.02832 8.72385 3.07122 8.8075 3.15702L9.79997 4.13185L10.7918 3.15565C10.878 3.07076 10.9769 3.02832 11.0884 3.02832C11.2 3.02832 11.2976 3.07122 11.3812 3.15702L12.3737 4.13185L13.3655 3.15565C13.4517 3.07076 13.5506 3.02832 13.6621 3.02832C13.7737 3.02832 13.8713 3.07122 13.9549 3.15702L14.9474 4.13185L15.9392 3.15565C16.0254 3.07076 16.1243 3.02832 16.2358 3.02832C16.3474 3.02832 16.445 3.07122 16.5286 3.15702L17.5211 4.13185L18.2139 3.43908C18.3361 3.31686 18.4627 3.27601 18.5938 3.31654C18.7248 3.35709 18.7903 3.45669 18.7903 3.61535V17.9171C18.7903 18.5575 18.5685 19.0996 18.1249 19.5433C17.6812 19.9869 17.1392 20.2087 16.4987 20.2087H5.49867ZM16.4987 18.8337C16.7584 18.8337 16.9761 18.7459 17.1518 18.5702C17.3275 18.3945 17.4153 18.1768 17.4153 17.9171V5.08374H7.33201V15.6254H14.7535C14.9882 15.6254 15.185 15.7048 15.3438 15.8636C15.5026 16.0224 15.582 16.2192 15.582 16.454V17.9171C15.582 18.1768 15.6699 18.3945 15.8455 18.5702C16.0212 18.7459 16.239 18.8337 16.4987 18.8337ZM9.08953 8.52122C8.90033 8.52122 8.74227 8.45531 8.61534 8.32349C8.48843 8.19166 8.42497 8.02831 8.42497 7.83344C8.42497 7.63856 8.49086 7.47531 8.62263 7.34369C8.75438 7.21207 8.91766 7.14626 9.11245 7.14626H12.9378C13.1326 7.14626 13.2958 7.21217 13.4276 7.34399C13.5594 7.47582 13.6253 7.63917 13.6253 7.83404C13.6253 8.02892 13.5594 8.19217 13.4276 8.32379C13.2958 8.45541 13.1326 8.52122 12.9378 8.52122H9.08953ZM9.08953 11.2712C8.90033 11.2712 8.74227 11.2053 8.61534 11.0735C8.48843 10.9417 8.42497 10.7783 8.42497 10.5834C8.42497 10.3886 8.49086 10.2253 8.62263 10.0937C8.75438 9.96207 8.91766 9.89626 9.11245 9.89626H12.9378C13.1326 9.89626 13.2958 9.96217 13.4276 10.094C13.5594 10.2258 13.6253 10.3892 13.6253 10.584C13.6253 10.7789 13.5594 10.9422 13.4276 11.0738C13.2958 11.2054 13.1326 11.2712 12.9378 11.2712H9.08953ZM15.5291 8.64462C15.3047 8.64462 15.1134 8.56559 14.9553 8.40753C14.7973 8.24946 14.7182 8.0582 14.7182 7.83374C14.7182 7.60928 14.7973 7.41802 14.9553 7.25995C15.1134 7.10189 15.3047 7.02286 15.5291 7.02286C15.7536 7.02286 15.9448 7.10189 16.1029 7.25995C16.261 7.41802 16.34 7.60928 16.34 7.83374C16.34 8.0582 16.261 8.24946 16.1029 8.40753C15.9448 8.56559 15.7536 8.64462 15.5291 8.64462ZM15.5291 11.3946C15.3047 11.3946 15.1134 11.3156 14.9553 11.1575C14.7973 10.9995 14.7182 10.8082 14.7182 10.5837C14.7182 10.3593 14.7973 10.168 14.9553 10.01C15.1134 9.85189 15.3047 9.77286 15.5291 9.77286C15.7536 9.77286 15.9448 9.85189 16.1029 10.01C16.261 10.168 16.34 10.3593 16.34 10.5837C16.34 10.8082 16.261 10.9995 16.1029 11.1575C15.9448 11.3156 15.7536 11.3946 15.5291 11.3946ZM5.49867 18.8337H14.207V17.0004H4.58201V17.9171C4.58201 18.1768 4.66986 18.3945 4.84555 18.5702C5.02124 18.7459 5.23895 18.8337 5.49867 18.8337Z"
                          :fill="tab == 2 ? 'white' : '#003765'"
                        />
                      </g>
                    </svg>
                  </div>
                  <div class="ml-[4px] flex items-center">ใบเสร็จรับเงิน</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          class="flex justify-end items-center rounded-[12px] mt-[14px] col-md-6"
        >
          <vs-button
            class="!float-right"
            id="createPaymentButton"
            :active="active == 1"
            @click="selectMenu('Partial Payment', userInvoice[0])"
          >
            เพิ่มหลักฐานการชำระเงิน
          </vs-button>
        </div>
      </div>

      <div
        class="w-[100%] h-[1px] mt-[24px] mb-[24px] bg-gray-200 border-0 dark:bg-gray-700"
      ></div>
      <div
        v-if="selected.length > 0"
        @click="PDFPrint()"
        class="h-[36px] flex rounded-[12px] mt-[12px] cursor-pointer"
      >
        <div class="flex justify-center items-center">
          <svg
            width="22"
            height="23"
            viewBox="0 0 22 23"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <mask
              id="mask0_3430_22284"
              style="mask-type: alpha"
              maskUnits="userSpaceOnUse"
              x="0"
              y="0"
              width="22"
              height="23"
            >
              <rect y="0.5" width="22" height="22" fill="#D9D9D9" />
            </mask>
            <g mask="url(#mask0_3430_22284)">
              <path
                d="M11 14.469C10.8895 14.469 10.7867 14.4514 10.6915 14.4161C10.5963 14.3809 10.5058 14.3203 10.42 14.2345L7.56956 11.3841C7.44265 11.2572 7.37772 11.0976 7.37479 10.9055C7.37184 10.7134 7.43676 10.5509 7.56956 10.4181C7.70235 10.2853 7.8657 10.2166 8.05961 10.2118C8.25351 10.2071 8.41687 10.2712 8.54968 10.404L10.3125 12.1668V5.15427C10.3125 4.95919 10.3783 4.79584 10.5099 4.66422C10.6415 4.53261 10.8049 4.4668 11 4.4668C11.1951 4.4668 11.3584 4.53261 11.49 4.66422C11.6216 4.79584 11.6875 4.95919 11.6875 5.15427V12.1668L13.4503 10.404C13.5772 10.2771 13.7391 10.2145 13.9359 10.2162C14.1328 10.218 14.2976 10.2853 14.4304 10.4181C14.5632 10.5509 14.6296 10.7119 14.6296 10.9011C14.6296 11.0903 14.5632 11.2513 14.4304 11.3841L11.5799 14.2345C11.4941 14.3203 11.4037 14.3809 11.3085 14.4161C11.2133 14.4514 11.1105 14.469 11 14.469ZM5.78206 18.3754C5.31902 18.3754 4.92708 18.215 4.60625 17.8942C4.28542 17.5733 4.125 17.1814 4.125 16.7183V14.9379C4.125 14.7428 4.19082 14.5795 4.32245 14.4479C4.45407 14.3162 4.61742 14.2504 4.8125 14.2504C5.00758 14.2504 5.17093 14.3162 5.30255 14.4479C5.43417 14.5795 5.49998 14.7428 5.49998 14.9379V16.7183C5.49998 16.7889 5.52936 16.8535 5.58811 16.9123C5.64689 16.971 5.71154 17.0004 5.78206 17.0004H16.2179C16.2884 17.0004 16.3531 16.971 16.4118 16.9123C16.4706 16.8535 16.5 16.7889 16.5 16.7183V14.9379C16.5 14.7428 16.5658 14.5795 16.6974 14.4479C16.829 14.3162 16.9924 14.2504 17.1875 14.2504C17.3825 14.2504 17.5459 14.3162 17.6775 14.4479C17.8091 14.5795 17.875 14.7428 17.875 14.9379V16.7183C17.875 17.1814 17.7145 17.5733 17.3937 17.8942C17.0729 18.215 16.6809 18.3754 16.2179 18.3754H5.78206Z"
                fill="#003765"
              />
            </g>
          </svg>
        </div>
        <div class="font-bold ml-[8px] flex justify-center items-center">
          ดาวน์โหลดใบแจ้งหนี้
        </div>
      </div>
      <div
        v-if="selected.length > 0"
        @click="PDFPrint('preview')"
        class="h-[36px] flex items-center rounded-[12px] mt-[12px] ml-[16px] cursor-pointer text-[#003765] underline"
      >
        ดูตัวอย่าง
      </div>
      <div class="mt-[20px]" v-if="tab == 1">
        <vs-table v-model="selected">
          <template #thead>
            <vs-tr>
              <!-- <vs-th>
                                <vs-checkbox :indeterminate="selected.length == users.length" v-model="allCheck"
                                    @change="selected = $vs.checkAll(selected, users)" />
                            </vs-th> -->
              <vs-th> </vs-th>
              <vs-th> หมายเลขใบแจ้งหนี้ </vs-th>
              <vs-th> ยอดรวม </vs-th>
              <vs-th> ชำระแล้ว </vs-th>
              <vs-th> วันที่สร้างเอกสาร </vs-th>
              <vs-th> สถานะ </vs-th>
              <vs-th> </vs-th>
            </vs-tr>
          </template>
          <template #tbody>
            <template v-for="(tr, i) in userInvoice">
              <vs-tr
                :key="'invoice-row-' + tr.id"
                :data="tr"
                :is-selected="!!selected.includes(tr)"
                :class="{ 'opacity-50 bg-gray-100': tr.attributes.debtMovedToNextBill }"
              >
                <!-- <vs-td checkbox>
                                <vs-checkbox :val="tr" v-model="selected" />
                            </vs-td> -->
                <vs-td>
                  <button
                    @click="toggleRowDetail(expandedInvoiceRows, tr.id)"
                    title="รายละเอียด"
                    class="p-1 rounded hover:bg-gray-100 text-gray-500"
                  >
                    {{ isRowExpanded(expandedInvoiceRows, tr.id) ? "▲" : "▼" }}
                  </button>
                </vs-td>
                <vs-td>
                  {{ tr.attributes.invoiceNumber }}
                </vs-td>
                <vs-td>
                  <!-- <vs-input  v-model="tr.attributes.total"/>   -->
                  {{ $formatNumber(tr.attributes.total) }}
                </vs-td>
                <vs-td>
                  <vs-input v-model="tr.attributes.paid" />
                </vs-td>
                <vs-td>
                  {{ convertDateNoTime(tr.attributes.createdAt) }}
                </vs-td>
                <vs-td>
                  <div class="flex items-center justify-start">
                    <div
                      v-if="tr.attributes.debtMovedToNextBill"
                      class="h-[36px] w-[auto] flex items-center justify-center pl-[12px] pr-[12px] rounded-[12px] pb-[4px] pt-[4px] bg-[#E5E7EB] text-[#6B7280]"
                    >
                      ยอดคงเหลือย้ายไปบิลถัดไป
                    </div>
                    <div
                      v-else
                      class="h-[36px] w-[auto] flex items-center justify-center pl-[12px] pr-[12px] rounded-[12px] pb-[4px] pt-[4px]"
                      :class="paymentStatusClass(tr.attributes.paymentStatus)"
                    >
                      {{ thaiPaymentStatus(tr.attributes.paymentStatus) }}
                    </div>
                    <div
                      v-if="parseFloat(tr.attributes.creditApplied) > 0"
                      class="ml-[6px] h-[28px] flex items-center justify-center px-[8px] rounded-[8px] bg-[#D6F5E3] text-[#0B9A3C] text-[11px] font-semibold whitespace-nowrap"
                      :title="'ใช้เครดิตจากยอดชำระเกินคราวก่อน ' + $formatNumber(tr.attributes.creditApplied) + ' บาท'"
                    >
                      ✓ ใช้เครดิต
                    </div>
                  </div>
                </vs-td>
                <vs-td>
                  <div class="flex items-center gap-[6px]">
                    <button
                      @click="PDFPrintInvoice(tr, 'preview')"
                      title="ดูตัวอย่าง"
                      class="px-2 py-1 bg-white rounded-lg shadow-sm hover:shadow-md transition-shadow duration-200 flex items-center justify-center border border-gray-200 text-gray-500 hover:text-gray-700 text-xs"
                    >
                      ดูตัวอย่าง
                    </button>
                    <button
                      @click="PDFPrintInvoice(tr)"
                      title="ดาวน์โหลด"
                      class="p-2 bg-white rounded-lg shadow-sm hover:shadow-md transition-shadow duration-200 flex items-center justify-center border border-gray-200"
                    >
                      <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        class="text-gray-500 hover:text-gray-700"
                      >
                        <mask
                          id="mask0_2691_23279"
                          style="mask-type: alpha"
                          maskUnits="userSpaceOnUse"
                          x="0"
                          y="0"
                          width="24"
                          height="24"
                        >
                          <rect width="24" height="24" fill="#D9D9D9" />
                        </mask>
                        <g mask="url(#mask0_2691_23279)">
                          <path
                            d="M12 15.2386C11.8795 15.2386 11.7673 15.2194 11.6634 15.1809C11.5596 15.1425 11.4609 15.0765 11.3673 14.9829L8.2577 11.8733C8.11925 11.7348 8.04842 11.5608 8.04522 11.3512C8.04201 11.1416 8.11283 10.9643 8.2577 10.8195C8.40257 10.6746 8.58077 10.5996 8.7923 10.5945C9.00383 10.5893 9.18204 10.6592 9.32692 10.8041L11.25 12.7272V5.07712C11.25 4.86431 11.3218 4.68611 11.4654 4.54252C11.609 4.39894 11.7872 4.32715 12 4.32715C12.2128 4.32715 12.391 4.39894 12.5346 4.54252C12.6782 4.68611 12.7499 4.86431 12.7499 5.07712V12.7272L14.673 10.8041C14.8115 10.6656 14.9881 10.5974 15.2028 10.5993C15.4176 10.6012 15.5974 10.6746 15.7422 10.8195C15.8871 10.9643 15.9595 11.14 15.9595 11.3464C15.9595 11.5528 15.8871 11.7284 15.7422 11.8733L12.6327 14.9829C12.5391 15.0765 12.4403 15.1425 12.3365 15.1809C12.2327 15.2194 12.1205 15.2386 12 15.2386ZM6.3077 19.5002C5.80257 19.5002 5.375 19.3252 5.025 18.9752C4.675 18.6252 4.5 18.1976 4.5 17.6925V15.7502C4.5 15.5374 4.5718 15.3592 4.7154 15.2156C4.85898 15.072 5.03718 15.0002 5.25 15.0002C5.46282 15.0002 5.64102 15.072 5.7846 15.2156C5.92818 15.3592 5.99997 15.5374 5.99997 15.7502V17.6925C5.99997 17.7694 6.03202 17.8399 6.09612 17.904C6.16024 17.9681 6.23077 18.0002 6.3077 18.0002H17.6922C17.7692 18.0002 17.8397 17.9681 17.9038 17.904C17.9679 17.8399 18 17.7694 18 17.6925V15.7502C18 15.5374 18.0718 15.3592 18.2154 15.2156C18.3589 15.072 18.5371 15.0002 18.75 15.0002C18.9628 15.0002 19.141 15.072 19.2845 15.2156C19.4281 15.3592 19.5 15.5374 19.5 15.7502V17.6925C19.5 18.1976 19.325 18.6252 18.975 18.9752C18.625 19.3252 18.1974 19.5002 17.6922 19.5002H6.3077Z"
                            fill="currentColor"
                          />
                        </g>
                      </svg>
                    </button>
                  </div>
                </vs-td>
              </vs-tr>
              <vs-tr
                :key="'invoice-detail-' + tr.id"
                v-if="isRowExpanded(expandedInvoiceRows, tr.id)"
              >
                <vs-td colspan="7">
                  <div class="grid grid-cols-3 gap-4 p-3 bg-gray-50 rounded-lg">
                    <div>
                      <label class="text-xs text-gray-500">ค่าเช่าห้อง</label>
                      <div
                        v-if="
                          tr.attributes.debtMovedToNextBill ||
                          tr.attributes.paymentStatus === 'Paid' ||
                          tr.attributes.paymentStatus === 'Partial Paid' ||
                          tr.attributes.paymentStatus === 'Waiting Review'
                        "
                      >
                        <vs-input disabled v-model="tr.attributes.roomPrice" />
                      </div>
                      <div v-else>
                        <vs-input
                          v-model="tr.attributes.roomPrice"
                          @change="activeSaveButton(tr.id)"
                        />
                      </div>
                    </div>
                    <div>
                      <label class="text-xs text-gray-500">ค่าน้ำ</label>
                      <div
                        v-if="
                          tr.attributes.debtMovedToNextBill ||
                          tr.attributes.paymentStatus === 'Paid' ||
                          tr.attributes.paymentStatus === 'Partial Paid' ||
                          tr.attributes.paymentStatus === 'Waiting Review'
                        "
                      >
                        <vs-input disabled v-model="tr.attributes.waterPrice" />
                      </div>
                      <div v-else>
                        <vs-input
                          v-model="tr.attributes.waterPrice"
                          @change="activeSaveButton(tr.id)"
                        />
                      </div>
                    </div>
                    <div>
                      <label class="text-xs text-gray-500">ค่าไฟฟ้า</label>
                      <div
                        v-if="
                          tr.attributes.debtMovedToNextBill ||
                          tr.attributes.paymentStatus === 'Paid' ||
                          tr.attributes.paymentStatus === 'Partial Paid' ||
                          tr.attributes.paymentStatus === 'Waiting Review'
                        "
                      >
                        <vs-input disabled v-model="tr.attributes.electricPrice" />
                      </div>
                      <div v-else>
                        <vs-input
                          v-model="tr.attributes.electricPrice"
                          @change="activeSaveButton(tr.id)"
                        />
                      </div>
                    </div>
                    <div>
                      <label class="text-xs text-gray-500">ค่าส่วนกลาง</label>
                      <div
                        v-if="
                          tr.attributes.debtMovedToNextBill ||
                          tr.attributes.paymentStatus === 'Paid' ||
                          tr.attributes.paymentStatus === 'Partial Paid' ||
                          tr.attributes.paymentStatus === 'Waiting Review'
                        "
                      >
                        <vs-input disabled v-model="tr.attributes.communalPrice" />
                      </div>
                      <div v-else>
                        <vs-input
                          v-model="tr.attributes.communalPrice"
                          @change="activeSaveButton(tr.id)"
                        />
                      </div>
                    </div>
                    <div>
                      <label class="text-xs text-gray-500">ค่าบริการเสริม</label>
                      <div
                        v-if="
                          tr.attributes.debtMovedToNextBill ||
                          tr.attributes.paymentStatus === 'Paid' ||
                          tr.attributes.paymentStatus === 'Partial Paid' ||
                          tr.attributes.paymentStatus === 'Waiting Review'
                        "
                      >
                        <vs-input disabled v-model="tr.attributes.otherPrice" />
                      </div>
                      <div v-else>
                        <vs-input
                          v-model="tr.attributes.otherPrice"
                          @change="activeSaveButton(tr.id)"
                        />
                      </div>
                    </div>
                    <div>
                      <!-- Computed by the backend from the building's VAT rate on save. -->
                      <label class="text-xs text-gray-500">Vat</label>
                      <div>
                        <vs-input disabled v-model="tr.attributes.vat" />
                      </div>
                    </div>
                    <div class="flex items-end">
                      <vs-button
                        :id="'saveButton' + tr.id"
                        disabled
                        :active="active == 1"
                        @click="!tr.attributes.debtMovedToNextBill && updateRoomInvoice(tr)"
                      >
                        Save
                      </vs-button>
                      <!-- <vs-select
                                    v-if="tr.attributes.paymentStatus === 'Paid' || tr.attributes.paymentStatus === 'Partial Paid' || tr.attributes.paymentStatus === 'Waiting Review'"
                                    placeholder="เมนู" v-model="tr.attributes.lastEvent"
                                    @change="selectMenu(tr.attributes.lastEvent, tr)">
                                    <vs-option label="เลือกเมนู" value="Select Menu">
                                        เลือกเมนู
                                    </vs-option>
                                </vs-select>
                                <vs-select v-else placeholder="เมนู" v-model="tr.attributes.lastEvent"
                                    @change="selectMenu(tr.attributes.lastEvent, tr)">
                                    <vs-option label="เลือกเมนู" value="Select Menu">
                                        เลือกเมนู
                                    </vs-option>
                                    <vs-option label="อัพเดท" value="Update">
                                        อัพเดทใบแจ้งหนี้
                                    </vs-option>
                                    <vs-option label="ชำระเงิน" value="Full Payment">
                                        ชำระเงิน
                                    </vs-option>
                                    <vs-option label="ชำระบางส่วน" value="Partial Payment">
                                        ชำระบางส่วน
                                    </vs-option>
                                </vs-select> -->
                    </div>
                  </div>
                </vs-td>
              </vs-tr>
            </template>
          </template>
        </vs-table>
      </div>
      <div class="mt-[14px]" v-if="tab == 2">
        <vs-table v-model="selected">
          <template #thead>
            <vs-tr>
              <!-- <vs-th>
                                <vs-checkbox :indeterminate="selected.length == users.length" v-model="allCheck"
                                    @change="selected = $vs.checkAll(selected, users)" />
                            </vs-th> -->
              <vs-th> </vs-th>
              <vs-th> หมายเลขใบเสร็จรับเงิน </vs-th>
              <vs-th> ยอดรวม </vs-th>
              <vs-th> ชำระแล้ว </vs-th>
              <vs-th> วันที่ออกใบเสร็จ </vs-th>
              <vs-th> </vs-th>
            </vs-tr>
          </template>
          <template #tbody>
            <template v-for="(tr, i) in userReceipt">
              <vs-tr
                :key="'receipt-row-' + tr.id"
                :data="tr"
                :is-selected="!!selected.includes(tr)"
              >
                <!-- <vs-td checkbox>
                                <vs-checkbox :val="tr" v-model="selected" />
                            </vs-td> -->
                <vs-td>
                  <button
                    @click="toggleRowDetail(expandedReceiptRows, tr.id)"
                    title="รายละเอียด"
                    class="p-1 rounded hover:bg-gray-100 text-gray-500"
                  >
                    {{ isRowExpanded(expandedReceiptRows, tr.id) ? "▲" : "▼" }}
                  </button>
                </vs-td>
                <vs-td>
                  {{ tr.attributes.receiptNumber }}
                </vs-td>
                <vs-td>
                  {{ $formatNumber(tr.attributes.total) }}
                </vs-td>
                <vs-td>
                  {{ $formatNumber(tr.attributes.paidAmount) }}
                </vs-td>
                <vs-td>
                  {{ convertDateNoTime(tr.attributes.createdAt) }}
                </vs-td>
                <vs-td>
                  <svg
                    @click="PDFPrintReceipt(tr)"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <mask
                      id="mask0_2691_23279"
                      style="mask-type: alpha"
                      maskUnits="userSpaceOnUse"
                      x="0"
                      y="0"
                      width="24"
                      height="24"
                    >
                      <rect width="24" height="24" fill="#D9D9D9" />
                    </mask>
                    <g mask="url(#mask0_2691_23279)">
                      <path
                        d="M12 15.2386C11.8795 15.2386 11.7673 15.2194 11.6634 15.1809C11.5596 15.1425 11.4609 15.0765 11.3673 14.9829L8.2577 11.8733C8.11925 11.7348 8.04842 11.5608 8.04522 11.3512C8.04201 11.1416 8.11283 10.9643 8.2577 10.8195C8.40257 10.6746 8.58077 10.5996 8.7923 10.5945C9.00383 10.5893 9.18204 10.6592 9.32692 10.8041L11.25 12.7272V5.07712C11.25 4.86431 11.3218 4.68611 11.4654 4.54252C11.609 4.39894 11.7872 4.32715 12 4.32715C12.2128 4.32715 12.391 4.39894 12.5346 4.54252C12.6782 4.68611 12.7499 4.86431 12.7499 5.07712V12.7272L14.673 10.8041C14.8115 10.6656 14.9881 10.5974 15.2028 10.5993C15.4176 10.6012 15.5974 10.6746 15.7422 10.8195C15.8871 10.9643 15.9595 11.14 15.9595 11.3464C15.9595 11.5528 15.8871 11.7284 15.7422 11.8733L12.6327 14.9829C12.5391 15.0765 12.4403 15.1425 12.3365 15.1809C12.2327 15.2194 12.1205 15.2386 12 15.2386ZM6.3077 19.5002C5.80257 19.5002 5.375 19.3252 5.025 18.9752C4.675 18.6252 4.5 18.1976 4.5 17.6925V15.7502C4.5 15.5374 4.5718 15.3592 4.7154 15.2156C4.85898 15.072 5.03718 15.0002 5.25 15.0002C5.46282 15.0002 5.64102 15.072 5.7846 15.2156C5.92818 15.3592 5.99997 15.5374 5.99997 15.7502V17.6925C5.99997 17.7694 6.03202 17.8399 6.09612 17.904C6.16024 17.9681 6.23077 18.0002 6.3077 18.0002H17.6922C17.7692 18.0002 17.8397 17.9681 17.9038 17.904C17.9679 17.8399 18 17.7694 18 17.6925V15.7502C18 15.5374 18.0718 15.3592 18.2154 15.2156C18.3589 15.072 18.5371 15.0002 18.75 15.0002C18.9628 15.0002 19.141 15.072 19.2845 15.2156C19.4281 15.3592 19.5 15.5374 19.5 15.7502V17.6925C19.5 18.1976 19.325 18.6252 18.975 18.9752C18.625 19.3252 18.1974 19.5002 17.6922 19.5002H6.3077Z"
                        fill="#8396A6"
                      />
                    </g>
                  </svg>
                </vs-td>
              </vs-tr>
              <vs-tr
                :key="'receipt-detail-' + tr.id"
                v-if="isRowExpanded(expandedReceiptRows, tr.id)"
              >
                <vs-td colspan="6">
                  <div class="grid grid-cols-3 gap-4 p-3 bg-gray-50 rounded-lg">
                    <div>
                      <label class="text-xs text-gray-500">ค่าเช่าห้อง</label>
                      <div>{{ $formatNumber(tr.attributes.roomPrice) }}</div>
                    </div>
                    <div>
                      <label class="text-xs text-gray-500">ค่าน้ำ</label>
                      <div>{{ $formatNumber(tr.attributes.waterPrice) }}</div>
                    </div>
                    <div>
                      <label class="text-xs text-gray-500">ค่าไฟฟ้า</label>
                      <div>{{ $formatNumber(tr.attributes.electricPrice) }}</div>
                    </div>
                    <div>
                      <label class="text-xs text-gray-500">ค่าส่วนกลาง</label>
                      <div>{{ $formatNumber(tr.attributes.communalPrice) }}</div>
                    </div>
                    <div>
                      <label class="text-xs text-gray-500">ค่าบริการเสริม</label>
                      <div>{{ $formatNumber(tr.attributes.otherPrice) }}</div>
                    </div>
                    <div>
                      <label class="text-xs text-gray-500">Vat</label>
                      <div>{{ $formatNumber(tr.attributes.vat) }}</div>
                    </div>
                  </div>
                </vs-td>
              </vs-tr>
            </template>
          </template>
        </vs-table>
      </div>
      <div class="mt-[14px]" v-if="tab == 3">
        <vs-table>
          <template #thead>
            <vs-tr>
              <vs-th> วันเวลาที่โอน </vs-th>
              <!-- <vs-th>
                                Ref: Invoice Number
                            </vs-th> -->
              <vs-th> ธนาคาร </vs-th>
              <vs-th> หลักฐาน </vs-th>
              <vs-th> จำนวนเงิน </vs-th>
              <vs-th> สถานะ </vs-th>
              <vs-th> Receipt </vs-th>
              <vs-th> Action </vs-th>
            </vs-tr>
          </template>
          <template #tbody>
            <vs-tr :key="i" v-for="(tr, i) in userEvidencePayment" :data="tr">
              <vs-td>
                {{ formatEvidenceTransferDateTime(tr.attributes) }}
              </vs-td>
              <!-- <vs-td>
                                {{ tr.attributes.tenant_bills.data[0].attributes.invoiceNumber }}
                            </vs-td> -->
              <vs-td>
                {{ tr.attributes.bankName }}
              </vs-td>
              <vs-td>
                <div v-if="tr.attributes.evidence?.data">
                  <a
                    :href="
                      'https://api.resguru.app' +
                      tr.attributes.evidence.data.attributes.url
                    "
                    target="_blank"
                  >
                    {{ tr.attributes.evidence.data.attributes.name }}</a
                  >
                </div>
                <div v-else>
                  <div>No evidence uploaded</div>
                </div>
              </vs-td>
              <vs-td>
                {{ $formatNumber(tr.attributes.amount) }}
              </vs-td>
              <vs-td>
                {{ tr.attributes.evidenceStatus }}
              </vs-td>
              <vs-td>
                <div v-if="tr.attributes.tenant_receipt?.data">
                  {{
                    tr.attributes.tenant_receipt.data.attributes.receiptNumber
                  }}
                </div>
                <div v-else>-</div>
              </vs-td>
              <vs-td>
                <div
                  v-if="
                    !tr.attributes.tenant_receipt.data &&
                    tr.attributes.evidenceStatus == 'Waiting Review'
                  "
                >
                  <!-- <vs-button @click="createReceipt(tr)" small>รับชำระ</vs-button> -->
                  <vs-button
                    @click="selectMenu('Approve Payment', tr, tr.id)"
                    small
                    >รับชำระ</vs-button
                  >
                </div>
                <div
                  v-if="
                    !tr.attributes.tenant_receipt.data &&
                    tr.attributes.evidenceStatus == 'Waiting Review'
                  "
                >
                  <vs-button @click="cancelPayment(tr)" small
                    >ไม่รับชำระ</vs-button
                  >
                </div>
                <div v-else>-</div>
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </div>
      <div>
        <PDFgeneratorReceipt ref="childComponentPDFReceipt" />
        <PDFgenerator ref="childComponentPDF" />
      </div>
    </div>

    <!-- <b-modal centered v-model="createFullpayment" size="l" hide-backdrop hide-header-close hide-header hide-footer
            class="p-[-20px] text-custom">
            <div>
                <div class="flex justify-between">
                    <div class="text-custom flex justify-center items-center text-[16px] font-bold">
                        แนบหลักฐานการชำระแบบเต็มจำนวน</div>
                    <div @click="createFullpayment = false" class="cursor-pointer">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <mask id="mask0_417_4814" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0"
                                width="24" height="24">
                                <rect width="24" height="24" fill="#D9D9D9" />
                            </mask>
                            <g mask="url(#mask0_417_4814)">
                                <path
                                    d="M12.0005 13.0538L6.92737 18.1269C6.78892 18.2654 6.61489 18.3362 6.40527 18.3394C6.19567 18.3426 6.01844 18.2718 5.87357 18.1269C5.72869 17.982 5.65625 17.8064 5.65625 17.6C5.65625 17.3936 5.72869 17.218 5.87357 17.0731L10.9466 12L5.87357 6.92689C5.73511 6.78844 5.66427 6.6144 5.66107 6.40479C5.65786 6.19519 5.72869 6.01795 5.87357 5.87309C6.01844 5.7282 6.19407 5.65576 6.40047 5.65576C6.60687 5.65576 6.78251 5.7282 6.92737 5.87309L12.0005 10.9462L17.0736 5.87309C17.212 5.73462 17.3861 5.66379 17.5957 5.66059C17.8053 5.65737 17.9825 5.7282 18.1274 5.87309C18.2723 6.01795 18.3447 6.19359 18.3447 6.39999C18.3447 6.60639 18.2723 6.78202 18.1274 6.92689L13.0543 12L18.1274 17.0731C18.2658 17.2115 18.3367 17.3856 18.3399 17.5952C18.3431 17.8048 18.2723 17.982 18.1274 18.1269C17.9825 18.2718 17.8069 18.3442 17.6005 18.3442C17.3941 18.3442 17.2184 18.2718 17.0736 18.1269L12.0005 13.0538Z"
                                    fill="#5C6B79" />
                            </g>
                        </svg>
                    </div>
                </div>
                <div class="w-[100%] h-[1px]  mt-[24px] mb-[14px] bg-gray-200 border-0 dark:bg-gray-700"></div>
                <div class="text-custom">เลขที่ใบแจ้งหนี้ (Invoice)</div>
                <div>
                    <input disabled
                        class="w-[100%] h-[36px]  rounded-[12px] pl-[8px] pr-[8px] text-custom bg-[#F3F7FA] mt-[8px]"
                        v-model="fullPaymentForm.invoiceName" />
                    <input class="w-[100%] h-[36px]  rounded-[12px] pl-[8px] pr-[8px] text-custom bg-[#F3F7FA] mt-[8px]"
                        v-model="fullPaymentForm.invoiceID" hidden />
                </div>
                <div class="mt-[14px]">
                    <div class="text-custom">ชื่อธนาคาร</div>
                    <div>
                        <input class="w-[100%] h-[36px]  rounded-[12px] pl-[8px] pr-[8px] text-custom bg-[#F3F7FA] mt-[8px]"
                            v-model="fullPaymentForm.bankName" />
                    </div>
                </div>
                <div class="mt-[14px]">
                    <div class="text-custom">ชื่อผู้โอน</div>
                    <div>
                        <input class="w-[100%] h-[36px]  rounded-[12px] pl-[8px] pr-[8px] text-custom bg-[#F3F7FA] mt-[8px]"
                            v-model="fullPaymentForm.accountBankName" />
                        <input class="w-[100%] h-[36px]  rounded-[12px] pl-[8px] pr-[8px] text-custom bg-[#F3F7FA] mt-[8px]"
                            v-model="fullPaymentForm.userID" hidden />
                    </div>
                </div>
                <div class="mt-[14px]">
                    <div class="text-custom">ยอดโอน (เต็มจำนวน)</div>
                    <div>
                        <input disabled
                            class="w-[100%] h-[36px]  rounded-[12px] pl-[8px] pr-[8px] text-custom bg-[#F3F7FA] mt-[8px]"
                            v-model="fullPaymentForm.amount" />
                    </div>
                </div>
                <div class="mt-[14px]">
                    <div class="text-custom">วันที่</div>
                    <div>
                        <DateField class="w-[100%] mt-[8px]"
                            v-model="fullPaymentForm.paymentDate" />
                    </div>
                </div>
                <div class="mt-[14px]">
                    <div class="text-custom">เวลา</div>
                    <div>
                        <input type="time"
                            class="w-[100%] h-[36px]  rounded-[12px] pl-[8px] pr-[8px] text-custom bg-[#F3F7FA] mt-[8px]"
                            v-model="fullPaymentForm.paymentTime" />
                    </div>
                </div>
                <div class="mt-[14px]">
                    <div class="text-custom">แนบหลักฐานการโอน</div>
                    <div class="mt-[4px] flex">
                        <input class="h-[28px] w-[120px] rounded-[12px] border flex justify-start" id="upload"
                            ref="FullPayment" hidden @change="setUploadFileFullPayment()" type="file" />
                        <label for="upload">
                            <div
                                class="h-[28px] w-[120px] flex justify-center text-custom items-center bg-[#165D98] text-[14px] text-[white] rounded-[12px] cursor-pointer">
                                อัพโหลดรูปภาพ</div>
                        </label>
                        <div v-if="this.fileFullPayment.name"
                            class="text-[#5C6B79] text-custom flex justify-center items-center ml-[8px] text-[12px]">
                            {{ this.fileFullPayment.name }}</div>
                        <div v-else
                            class="text-[#5C6B79] text-custom flex justify-center items-center ml-[8px] text-[12px]">
                            ยังไม่ได้เลือกไฟล์</div>
                    </div>
                </div>
                <div class="flex justify-end mt-[30px]">
                    <div>
                        <vs-button dark shadow @click="createFullpayment = false">
                            <div class="text-custom">ยกเลิก</div>
                        </vs-button>
                    </div>
                    <div>
                        <vs-button @click="createFullPayment()" color="#003765">
                            <div class="text-custom">บันทึก</div>
                        </vs-button>
                    </div>
                </div>
            </div>
        </b-modal> -->

    <b-modal
      centered
      v-model="createPartialPayment"
      size="l"
      hide-backdrop
      hide-header-close
      hide-header
      hide-footer
      class="p-[-20px] text-custom"
    >
      <div>
        <div class="flex justify-between">
          <div
            class="text-custom flex justify-center items-center text-[16px] font-bold"
          >
            แนบหลักฐานการชำระเงิน
          </div>
          <div @click="createPartialPayment = false" class="cursor-pointer">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <mask
                id="mask0_417_4814"
                style="mask-type: alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="24"
                height="24"
              >
                <rect width="24" height="24" fill="#D9D9D9" />
              </mask>
              <g mask="url(#mask0_417_4814)">
                <path
                  d="M12.0005 13.0538L6.92737 18.1269C6.78892 18.2654 6.61489 18.3362 6.40527 18.3394C6.19567 18.3426 6.01844 18.2718 5.87357 18.1269C5.72869 17.982 5.65625 17.8064 5.65625 17.6C5.65625 17.3936 5.72869 17.218 5.87357 17.0731L10.9466 12L5.87357 6.92689C5.73511 6.78844 5.66427 6.6144 5.66107 6.40479C5.65786 6.19519 5.72869 6.01795 5.87357 5.87309C6.01844 5.7282 6.19407 5.65576 6.40047 5.65576C6.60687 5.65576 6.78251 5.7282 6.92737 5.87309L12.0005 10.9462L17.0736 5.87309C17.212 5.73462 17.3861 5.66379 17.5957 5.66059C17.8053 5.65737 17.9825 5.7282 18.1274 5.87309C18.2723 6.01795 18.3447 6.19359 18.3447 6.39999C18.3447 6.60639 18.2723 6.78202 18.1274 6.92689L13.0543 12L18.1274 17.0731C18.2658 17.2115 18.3367 17.3856 18.3399 17.5952C18.3431 17.8048 18.2723 17.982 18.1274 18.1269C17.9825 18.2718 17.8069 18.3442 17.6005 18.3442C17.3941 18.3442 17.2184 18.2718 17.0736 18.1269L12.0005 13.0538Z"
                  fill="#5C6B79"
                />
              </g>
            </svg>
          </div>
        </div>
        <div
          class="w-[100%] h-[1px] mt-[24px] mb-[14px] bg-gray-200 border-0 dark:bg-gray-700"
        ></div>
        <!-- <div class="text-custom">เลขที่ใบแจ้งหนี้ (Invoice)</div>
                <div>
                    <input disabled
                        class="w-[100%] h-[36px]  rounded-[12px] pl-[8px] pr-[8px] text-custom bg-[#F3F7FA] mt-[8px]"
                        v-model="partialPaymentForm.invoiceName" />
                    <input class="w-[100%] h-[36px]  rounded-[12px] pl-[8px] pr-[8px] text-custom bg-[#F3F7FA] mt-[8px]"
                        v-model="partialPaymentForm.invoiceID" hidden />
                </div> -->
        <div class="mt-[14px]">
          <div class="text-custom">วิธีการชำระเงิน</div>
          <div>
            <!-- <input class="w-[100%] h-[36px]  rounded-[12px] pl-[8px] pr-[8px] text-custom bg-[#F3F7FA] mt-[8px]"
                            v-model="partialPaymentForm.paymentType" /> -->
            <select
              class="w-[100%] h-[36px] rounded-[12px] pl-[8px] pr-[8px] text-custom bg-[#F3F7FA] mt-[8px]"
              required
              v-model="partialPaymentForm.paymentType"
            >
              <option value="Bank" selected>โอนธนาคาร</option>
              <option value="Cash">เงินสด</option>
              <option value="Other">อื่น ๆ</option>
            </select>
          </div>
        </div>
        <div class="mt-[14px]">
          <div class="text-custom">ชื่อธนาคาร</div>
          <!-- <div>
            <input
              class="w-[100%] h-[36px] rounded-[12px] pl-[8px] pr-[8px] text-custom bg-[#F3F7FA] mt-[8px]"
              v-model="partialPaymentForm.bankName"
            />
          </div> -->
          <div>
            <select
              placeholder="Select"
              v-model="partialPaymentForm.bankName"
              class="w-[100%] h-[36px] rounded-[12px] pl-[8px] pr-[8px] text-custom bg-[#F3F7FA] mt-[8px]"
            >
              <option label="เลือก" value="0" disabled>เลือก</option>
              <option label="ธนาคารกรุงเทพ" value="ธนาคารกรุงเทพ">
                ธนาคารกรุงเทพ
              </option>
              <option label="ธนาคารกสิกรไทย" value="ธนาคารกสิกรไทย">
                ธนาคารกสิกรไทย
              </option>
              <option label="ธนาคารกรุงไทย" value="ธนาคารกรุงไทย">
                ธนาคารกรุงไทย
              </option>
              <option label="ธนาคารทหารไทย" value="ธนาคารทหารไทย">
                ธนาคารทหารไทย
              </option>
              <option label="ธนาคารไทยพาณิชย์" value="ธนาคารไทยพาณิชย์">
                ธนาคารไทยพาณิชย์
              </option>
              <option label="ธนาคารกรุงศรีอยุธยา" value="ธนาคารกรุงศรีอยุธยา">
                ธนาคารกรุงศรีอยุธยา
              </option>
              <option label="ธนาคารเกียรตินาคิน" value="ธนาคารเกียรตินาคิน">
                ธนาคารเกียรตินาคิน
              </option>
              <option label="ธนาคารซีไอเอ็มบีไทย" value="ธนาคารซีไอเอ็มบีไทย">
                ธนาคารซีไอเอ็มบีไทย
              </option>
              <option label="ธนาคารทิสโก้" value="ธนาคารทิสโก้">
                ธนาคารทิสโก้
              </option>
              <option label="ธนาคารธนชาต" value="ธนาคารธนชาต">
                ธนาคารธนชาต
              </option>
              <option label="ธนาคารยูโอบี" value="ธนาคารยูโอบี">
                ธนาคารยูโอบี
              </option>
              <option
                label="ธนาคารสแตนดาร์ดชาร์เตอร์ด"
                value="ธนาคารสแตนดาร์ดชาร์เตอร์ด"
              >
                ธนาคารสแตนดาร์ดชาร์เตอร์ด (ไทย)
              </option>
              <option
                label="ธนาคารไทยเครดิตเพื่อรายย่อย"
                value="ธนาคารไทยเครดิตเพื่อรายย่อย"
              >
                ธนาคารไทยเครดิตเพื่อรายย่อย
              </option>
              <option
                label="ธนาคารแลนด์แอนด์เฮาส์ "
                value="ธนาคารแลนด์แอนด์เฮาส์"
              >
                ธนาคารแลนด์ แอนด์ เฮาส์
              </option>
              <option label="ธนาคารไอซีบีซี" value="ธนาคารไอซีบีซี">
                ธนาคารไอซีบีซี (ไทย)
              </option>
              <option
                label="ธนาคารพัฒนาวิสาหกิจขนาดกลางและขนาดย่อมแห่งประเทศไทย"
                value="ธนาคารพัฒนาวิสาหกิจขนาดกลางและขนาดย่อมแห่งประเทศไทย"
              >
                ธนาคารพัฒนาวิสาหกิจขนาดกลางและขนาดย่อมแห่งประเทศไทย
              </option>
              <option
                label="ธนาคารเพื่อการเกษตรและสหกรณ์การเกษตร"
                value="ธนาคารเพื่อการเกษตรและสหกรณ์การเกษตร"
              >
                ธนาคารเพื่อการเกษตรและสหกรณ์การเกษตร
              </option>
              <option
                label="ธนาคารเพื่อการส่งออกและนำเข้าแห่งประเทศไทย"
                value="ธนาคารเพื่อการส่งออกและนำเข้าแห่งประเทศไทย"
              >
                ธนาคารเพื่อการส่งออกและนำเข้าแห่งประเทศไทย
              </option>
              <option label="ธนาคารออมสิน" value="ธนาคารออมสิน">
                ธนาคารออมสิน
              </option>
              <option label="ธนาคารอาคารสงเคราะห์" value="ธนาคารอาคารสงเคราะห์">
                ธนาคารอาคารสงเคราะห์
              </option>
              <option
                label="ธนาคารอิสลามแห่งประเทศไทย"
                value="ธนาคารอิสลามแห่งประเทศไทย"
              >
                ธนาคารอิสลามแห่งประเทศไทย
              </option>
              <option label="ธนาคารแห่งประเทศจีน" value="ธนาคารแห่งประเทศจีน">
                ธนาคารแห่งประเทศจีน
              </option>
              <option
                label="ธนาคารซูมิโตโมมิตซุยทรัสต์"
                value="ธนาคารซูมิโตโมมิตซุยทรัสต์"
              >
                ธนาคารซูมิโตโม มิตซุย ทรัสต์ (ไทย)
              </option>
              <option
                label="ธนาคารฮ่องกงและเซี้ยงไฮ้แบงกิ้งคอร์ปอเรชั่น"
                value="ธนาคารฮ่องกงและเซี้ยงไฮ้แบงกิ้งคอร์ปอเรชั่น"
              >
                ธนาคารฮ่องกงและเซี้ยงไฮ้แบงกิ้งคอร์ปอเรชั่น จำกัด
              </option>
            </select>
          </div>
        </div>
        <div class="mt-[14px]">
          <div class="text-custom">ชื่อบัญชีธนาคาร</div>
          <div>
            <input
              class="w-[100%] h-[36px] rounded-[12px] pl-[8px] pr-[8px] text-custom bg-[#F3F7FA] mt-[8px]"
              v-model="partialPaymentForm.accountBankName"
            />
            <input
              class="w-[100%] h-[36px] rounded-[12px] pl-[8px] pr-[8px] text-custom bg-[#F3F7FA] mt-[8px]"
              v-model="partialPaymentForm.userID"
              hidden
            />
          </div>
        </div>
        <div class="mt-[14px]">
          <div class="text-custom">ยอดชำระ</div>
          <div>
            <input
              class="w-[100%] h-[36px] rounded-[12px] pl-[8px] pr-[8px] text-custom bg-[#F3F7FA] mt-[8px]"
              v-model="partialPaymentForm.amount"
            />
          </div>
        </div>
        <div class="mt-[14px]">
          <div class="text-custom">วันที่ชำระ</div>
          <div>
            <DateField
              class="w-[100%] mt-[8px]"
              v-model="partialPaymentForm.paymentDate"
              :required="true"
            />
          </div>
        </div>
        <div class="mt-[14px]">
          <div class="text-custom">เวลา</div>
          <div>
            <input
              type="time"
              class="w-[100%] h-[36px] rounded-[12px] pl-[8px] pr-[8px] text-custom bg-[#F3F7FA] mt-[8px]"
              v-model="partialPaymentForm.paymentTime"
              required
            />
          </div>
        </div>
        <div class="mt-[14px]">
          <div class="text-custom">แนบหลักฐานการชำระ</div>
          <div class="mt-[4px] flex">
            <input
              class="h-[28px] w-[120px] rounded-[12px] border flex justify-start"
              id="upload"
              ref="PartialPayment"
              hidden
              @change="setUploadFilePayment()"
              type="file"
            />
            <label for="upload">
              <div
                class="h-[28px] w-[120px] flex justify-center text-custom items-center bg-[#165D98] text-[14px] text-[white] rounded-[12px] cursor-pointer"
              >
                อัพโหลดรูปภาพ
              </div>
            </label>
            <div
              v-if="this.filePartialPayment.name"
              class="text-[#5C6B79] text-custom flex justify-center items-center ml-[8px] text-[12px]"
            >
              {{ this.filePartialPayment.name }}
            </div>
            <div
              v-else
              class="text-[#5C6B79] text-custom flex justify-center items-center ml-[8px] text-[12px]"
            >
              ยังไม่ได้เลือกไฟล์
            </div>
          </div>
        </div>
        <div class="flex justify-end mt-[30px]">
          <div>
            <vs-button dark shadow @click="createPartialPayment = false">
              <div class="text-custom">ยกเลิก</div>
            </vs-button>
          </div>
          <div>
            <vs-button @click="createPartial()" color="#003765">
              <div class="text-custom">บันทึก</div>
            </vs-button>
          </div>
        </div>
      </div>
    </b-modal>

    <b-modal
  centered
  v-model="createApprovePayment"
  size="xl"
  hide-backdrop
  hide-header-close
  hide-header
  hide-footer
  class="p-[-20px] text-custom"
>
  <div>
    <div class="flex justify-between">
      <div class="mt-[14px]">
  <div class="text-custom">อัตราภาษีมูลค่าเพิ่ม (VAT)</div>
  <div>
    <select
      class="w-[100%] h-[36px] rounded-[12px] pl-[8px] pr-[8px] text-custom bg-[#F3F7FA] mt-[8px]"
      v-model="approvePaymentForm.vatRate"
      @change="recalculateVat()"
    >
      <option value="0">0%</option>
      <option value="7">7%</option>
    </select>
  </div>
</div>
      <div
        class="text-custom flex justify-center items-center text-[16px] font-bold"
      >
        อนุมัติการชำระเงิน
      </div>
      <div @click="createApprovePayment = false" class="cursor-pointer">
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <mask
            id="mask0_417_4814"
            style="mask-type: alpha"
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="24"
            height="24"
          >
            <rect width="24" height="24" fill="#D9D9D9" />
          </mask>
          <g mask="url(#mask0_417_4814)">
            <path
              d="M12.0005 13.0538L6.92737 18.1269C6.78892 18.2654 6.61489 18.3362 6.40527 18.3394C6.19567 18.3426 6.01844 18.2718 5.87357 18.1269C5.72869 17.982 5.65625 17.8064 5.65625 17.6C5.65625 17.3936 5.72869 17.218 5.87357 17.0731L10.9466 12L5.87357 6.92689C5.73511 6.78844 5.66427 6.6144 5.66107 6.40479C5.65786 6.19519 5.72869 6.01795 5.87357 5.87309C6.01844 5.7282 6.19407 5.65576 6.40047 5.65576C6.60687 5.65576 6.78251 5.7282 6.92737 5.87309L12.0005 10.9462L17.0736 5.87309C17.212 5.73462 17.3861 5.66379 17.5957 5.66059C17.8053 5.65737 17.9825 5.7282 18.1274 5.87309C18.2723 6.01795 18.3447 6.19359 18.3447 6.39999C18.3447 6.60639 18.2723 6.78202 18.1274 6.92689L13.0543 12L18.1274 17.0731C18.2658 17.2115 18.3367 17.3856 18.3399 17.5952C18.3431 17.8048 18.2723 17.982 18.1274 18.1269C17.9825 18.2718 17.8069 18.3442 17.6005 18.3442C17.3941 18.3442 17.2184 18.2718 17.0736 18.1269L12.0005 13.0538Z"
              fill="#5C6B79"
            />
          </g>
        </svg>
      </div>
    </div>
    <div
      class="w-[100%] h-[1px] mt-[24px] mb-[14px] bg-gray-200 border-0 dark:bg-gray-700"
    ></div>

    <div class="mt-[14px]">
      <table class="w-full border-collapse">
        <thead>
          <tr class="bg-[#F3F7FA]">
            <th class="p-2 border text-left">ลำดับ<br>No.</th>
            <th class="p-2 border text-left">รายการ<br>Desc</th>
            <!-- <th class="p-2 border text-center">จำนวน<br>Qty</th> -->
            <th class="p-2 border text-right">ราคา<br>Unit Price</th>
            <!-- <th class="p-2 border text-right">จำนวนเงิน<br>Amount</th> -->
            <th class="p-2 border text-right">ภาษี<br>Vat</th>
            <th class="p-2 border text-right">รวมเงิน<br>Total Amount</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td class="p-2 border text-center">1</td>
            <td class="p-2 border">ค่าห้อง</td>
            <!-- <td class="p-2 border text-center">1.00</td> -->
            <!-- <td class="p-2 border text-right">0.00</td> -->
            <td class="p-2 border text-right">{{ $formatNumber(approvePaymentForm.roomPrice) }}</td>
            <td class="p-2 border text-right">-</td>
            <td class="p-2 border text-right">
              <input 
                class="w-full h-[36px] rounded-[8px] pl-[8px] pr-[8px] text-custom text-right bg-white" 
                v-model="approvePaymentForm.roomPrice" 
                @change="recalculateVat()"
              />
            </td>
          </tr>
          
          <tr>
            <td class="p-2 border text-center">2</td>
            <td class="p-2 border">ค่าน้ำ</td>
            <!-- <td class="p-2 border text-center">-</td> -->
            <!-- <td class="p-2 border text-right">-</td> -->
            <td class="p-2 border text-right">{{ $formatNumber((approvePaymentForm.waterPrice-approvePaymentForm.waterPriceVat).toFixed(2)) }}</td>
            <td class="p-2 border text-right">{{ $formatNumber(approvePaymentForm.waterPriceVat) }}</td>
            <td class="p-2 border text-right">
              <input 
                class="w-full h-[36px] rounded-[8px] pl-[8px] pr-[8px] text-custom text-right bg-white" 
                v-model="approvePaymentForm.waterPrice" 
                @change="recalculateVat()"
              />
            </td>
          </tr>
          
          <tr>
            <td class="p-2 border text-center">3</td>
            <td class="p-2 border">ค่าไฟ</td>
            <!-- <td class="p-2 border text-center">-</td> -->
            <!-- <td class="p-2 border text-right">-</td> -->
            <td class="p-2 border text-right">{{ $formatNumber((approvePaymentForm.electricPrice-approvePaymentForm.electricPriceVat).toFixed(2)) }}</td>
            <td class="p-2 border text-right">{{ $formatNumber(approvePaymentForm.electricPriceVat) }}</td>
            <td class="p-2 border text-right">
              <input 
                class="w-full h-[36px] rounded-[8px] pl-[8px] pr-[8px] text-custom text-right bg-white" 
                v-model="approvePaymentForm.electricPrice" 
                @change="recalculateVat()"
              />
            </td>
          </tr>
          
          <tr>
            <td class="p-2 border text-center">4</td>
            <td class="p-2 border">ค่าบริการ</td>
            <!-- <td class="p-2 border text-center">1.00</td> -->
            <!-- <td class="p-2 border text-right">{{ $formatNumber(approvePaymentForm.communalPrice) }}</td> -->
            <td class="p-2 border text-right">{{ $formatNumber((approvePaymentForm.communalPrice-approvePaymentForm.communalPriceVat).toFixed(2)) }}</td>
            <td class="p-2 border text-right">{{ $formatNumber(approvePaymentForm.communalPriceVat) }}</td>
            <td class="p-2 border text-right">
              <input 
                class="w-full h-[36px] rounded-[8px] pl-[8px] pr-[8px] text-custom text-right bg-white" 
                v-model="approvePaymentForm.communalPrice" 
                @change="recalculateVat()"
              />
            </td>
          </tr>

          <tr>
            <td class="p-2 border text-center">5</td>
            <td class="p-2 border">ค่าอื่นๆ</td>
            <td class="p-2 border text-right">{{ $formatNumber(approvePaymentForm.otherPrice) }}</td>
            <td class="p-2 border text-right">-</td>
            <td class="p-2 border text-right">
              <input
                class="w-full h-[36px] rounded-[8px] pl-[8px] pr-[8px] text-custom text-right bg-white"
                v-model="approvePaymentForm.otherPrice"
                @change="recalculateVat()"
              />
            </td>
          </tr>

          <tr v-if="Number(approvePaymentForm.carryOverAmount) > 0">
            <td class="p-2 border text-center">6</td>
            <td class="p-2 border">{{ approvePaymentForm.carryOverLabel }}</td>
            <td class="p-2 border text-right">{{ $formatNumber(approvePaymentForm.carryOverAmount) }}</td>
            <td class="p-2 border text-right">-</td>
            <td class="p-2 border text-right">
              <input
                class="w-full h-[36px] rounded-[8px] pl-[8px] pr-[8px] text-custom text-right bg-white"
                v-model="approvePaymentForm.carryOverAmount"
                @change="recalculateVat()"
              />
            </td>
          </tr>
          
          <tr class="bg-[#F3F7FA]">
            <td colspan="2" class="p-2 border text-right font-bold">รวม</td>
            <td class="p-2 border text-right">{{ $formatNumber(approvePaymentForm.subtotal) }}</td>
            <td class="p-2 border text-right">{{ $formatNumber(approvePaymentForm.vat) }}</td>
            <td class="p-2 border text-right font-bold">{{ $formatNumber(approvePaymentForm.total) }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="flex mt-[30px]">
      <div class="w-1/2 pr-4">
        <div class="text-custom">ยอดที่ชำระมา</div>
        <div>
          <input
            class="w-[100%] h-[36px] rounded-[12px] pl-[8px] pr-[8px] text-custom bg-[#F3F7FA] mt-[8px]"
            v-model="approvePaymentForm.amount"
            @change="calAfterFine()"
          />
        </div>
      </div>
      
      <div class="w-1/2 pl-4">
        <div class="text-custom">ค่าปรับ</div>
        <div>
          <input
            class="w-[100%] h-[36px] rounded-[12px] pl-[8px] pr-[8px] text-custom bg-[#F3F7FA] mt-[8px]"
            v-model="approvePaymentForm.fineAmount"
            @change="calAfterFine()"
          />
        </div>
      </div>
    </div>
    
    <div class="mt-[14px]">
      <div class="text-custom">สรุปยอดหลังหักค่าปรับ</div>
      <div>
        <input
          id="afterFine"
          class="w-[100%] h-[36px] rounded-[12px] pl-[8px] pr-[8px] text-custom bg-[#F3F7FA] mt-[8px] font-bold"
          disabled
          v-model="approvePaymentForm.afterFine"
        />
      </div>
    </div>

    <div class="flex mt-[14px]">
      <div class="w-1/2 pr-4">
        <div class="text-custom">วันที่</div>
        <div>
          <DateField
            class="w-[100%] mt-[8px]"
            v-model="approvePaymentForm.paymentDate"
          />
        </div>
      </div>
      
      <div class="w-1/2 pl-4">
        <div class="text-custom">เวลา</div>
        <div>
          <input
            type="time"
            class="w-[100%] h-[36px] rounded-[12px] pl-[8px] pr-[8px] text-custom bg-[#F3F7FA] mt-[8px]"
            v-model="approvePaymentForm.paymentTime"
          />
        </div>
      </div>
    </div>

    <div class="flex justify-end mt-[30px]">
      <div>
        <vs-button dark shadow class="mr-[10px]" @click="createApprovePayment = false">
          <div class="text-custom">ยกเลิก</div>
        </vs-button>
      </div>
      <div>
        <vs-button @click="createReceipt()" color="#003765">
          <div class="text-custom text-white">บันทึก</div>
        </vs-button>
      </div>
    </div>
  </div>
</b-modal>
  </div>
</template>
<script>
import axios from "axios";
import { authHeaders } from "@/utils/authHeaders";
import { getVatRate } from "@/utils/billMath";
import { degrees, PDFDocument, rgb, StandardFonts } from "pdf-lib";
import { convertDateNoTime } from "@/components/hook/hook";
import download from "downloadjs";
import PDFgenerator from "@/views/payment/components/PDFgenerator";
import PDFgeneratorReceipt from "@/views/payment/components/PDFgeneratorReceipt";


export default {
  components: { PDFgenerator, PDFgeneratorReceipt },
  data() {
    return {
      popup_filter: false,
      menu_option: 0,
      createFullpayment: false,
      createPartialPayment: false,
      createApprovePayment: false,
      tab: 1,
      active: 0,
      allCheck: false,
      selected: [],
      users: [
        {
          id: 1,
          name: "ใบแจ้งหนี้#190523",
          type: "ห้องพร้อมเฟอร์นิเจอร์",
          price: "3,500",
          price2: "3,500",
          price3: "3,500",
          price4: "3,500",
          price5: "3,500",
          price6: "3,500",
          status: "ยังไม่ชำระ",
        },
        {
          id: 2,
          name: "ใบแจ้งหนี้#190523",
          type: "ห้องพร้อมเฟอร์นิเจอร์",
          price: "3,500",
          price2: "3,500",
          price3: "3,500",
          price4: "3,500",
          price5: "3,500",
          price6: "3,500",
          status: "ยังไม่ชำระ",
        },
        {
          id: 3,
          name: "ใบแจ้งหนี้#190523",
          type: "ห้องพร้อมเฟอร์นิเจอร์",
          price: "3,500",
          price2: "3,500",
          price3: "3,500",
          price4: "3,500",
          price5: "3,500",
          price6: "3,500",
          status: "ยังไม่ชำระ",
        },
      ],
      users2: [
        {
          id: "28/03/2023 : 10.00 น.",
          name: "Kbank",
          username: "4,500",
        },
      ],
      userProfile: [],
      userInvoice: [],
      userUnpaidInvoice: [],
      userPayRemain: 0,
      userReceipt: [],
      contractProfile: null,
      roomDetail: null,
      expandedInvoiceRows: [],
      expandedReceiptRows: [],
      userProfileImage: "",
      userEvidencePayment: [],
      PartialPayment: [],
      fileFullPayment: [],
      filePartialPayment: [],
      fullPaymentForm: {
        invoiceID: "",
        invoiceName: "",
        roomName: "",
        userID: "",
        bankName: "",
        accountBankName: "",
        amount: 0,
        paymentDate: "",
        paymentTime: "",
        building: "",
      },
      partialPaymentForm: {
        invoiceID: "",
        invoiceName: "",
        roomName: "",
        userID: "",
        bankName: "",
        accountBankName: "",
        amount: 0,
        paymentDate: "",
        paymentTime: "",
        building: "",
      },
      // approvePaymentForm: {
      //   invoiceID: "",
      //   invoiceName: "",
      //   roomName: "",
      //   userID: "",
      //   bankName: "",
      //   accountBankName: "",
      //   amount: 0,
      //   paymentDate: "",
      //   paymentTime: "",
      //   building: "",
      //   approver: "",
      //   fineamount: "",
      //   afterFine: "",
      //   building: "",
      // },
      approvePaymentForm: {
        invoiceID: "",
        invoiceNumber: "",
        roomName: "",
        userID: "",
        roomPrice: 0,
        waterPrice: 0,
        electricPrice: 0,
        communalPrice: 0,
        waterPriceVat: 0,
        electricPriceVat: 0,
        communalPriceVat:0,
        otherPrice: 0,
        carryOverAmount: 0,
        carryOverLabel: "ค่าใช้จ่ายค้างจากเดือนก่อนหน้า",
        subtotal: 0,
        vat: 0,
        vatRate: 0,
        total: 0,
        amount: 0,
        fineAmount: 0,
        afterFine: 0,
        paymentDate: "",
        paymentTime: "",
        building: "",
        room: "",
        receiptNumber: "",
        tenant_evidence_payment: "",
        user_sign_contract: "",
        evidenceStatus: "",
        evidenceUrl: "",
        evidenceName: ""
      },
      approvalAllocationBase: null,
      convertDateNoTime,
    };
  },
  created() {
    const loading = this.$vs.loading({});
    setTimeout(() => {
      loading.close();
    }, 1000);
  },
  mounted() {
    this.getUserProfile();
    this.getInvoice();
    this.getReceipt();
    this.getEvidence();
  },
  methods: {
    routeTo(path) {
      this.$router.push({
        path: path,
      });
    },
    thaiPaymentStatus(status) {
      const map = {
        'Not Paid':          'ยังไม่ชำระ',
        'Partial Paid':      'ชำระบางส่วน',
        'Paid':              'ชำระแล้ว',
        'Waiting Review':    'รอตรวจสอบ',
        'In Review Progress':'กำลังตรวจสอบ',
        'Over Due':          'เกินกำหนดชำระ',
      };
      return map[status] || status || '-';
    },
    paymentStatusClass(status) {
      if (status === 'Paid') {
        return 'bg-[#CFFBDA] text-[#0B9A3C]';
      }
      if (status === 'Not Paid' || status === 'Over Due') {
        return 'bg-[#FFE1E8] text-[#EA2F5C]';
      }
      if (status === 'Waiting Review' || status === 'In Review Progress') {
        return 'bg-[#DBEAFE] text-[#1D4ED8]';
      }
      // Partial Paid and any other
      return 'bg-[#FFF2BC] text-[#D48C00]';
    },
    checkNull(text) {
      if (text == "" || text === null) {
        return "-";
      } else {
        return text;
      }
    },
    getCurrentApprovePaymentDate(date = new Date()) {
      return date.toISOString().slice(0, 10);
    },
    getCurrentApprovePaymentTime(date = new Date()) {
      return date.toTimeString().slice(0, 5);
    },
    normalizeApprovePaymentDate(value) {
      if (!value) {
        return this.getCurrentApprovePaymentDate();
      }

      if (/^\d{2}\/\d{2}\/\d{4}$/.test(value)) {
        const [day, month, year] = value.split("/");
        return `${year}-${month}-${day}`;
      }

      return value;
    },
    formatEvidenceTransferDateTime(attributes = {}) {
      const paymentDate = attributes.paymentDate || attributes.createdAt;
      const formattedDate = paymentDate
        ? this.convertDateNoTime(paymentDate)
        : "-";

      const paymentTime = typeof attributes.paymentTime === "string"
        ? attributes.paymentTime.replace(/\.\d+$/, "").trim()
        : "";

      if (!paymentTime) {
        return formattedDate;
      }

      return `${formattedDate} ${paymentTime}`;
    },
    toMoney(value) {
      const num = Number(value);
      if (!Number.isFinite(num)) {
        return 0;
      }

      return Math.round(num * 100) / 100;
    },
    getExpectedRemain(attributes = {}) {
      if (attributes.debtMovedToNextBill) {
        // This bill's remaining debt was intentionally carried forward onto
        // a newer bill (see backend's carryForwardDebt) - remainPaid was
        // zeroed on purpose and total/paid were left untouched, so don't
        // reconstruct a nonzero remain from them here.
        return 0;
      }

      const total = this.toMoney(attributes.total);
      const paid = this.toMoney(attributes.paid);

      return this.toMoney(Math.max(0, total - paid));
    },
    getInvoiceRemainingAmount(invoice = {}) {
      const attributes = invoice.attributes || invoice || {};
      const storedRemainPaid = Number.isFinite(attributes.remainPaid)
        ? this.toMoney(attributes.remainPaid)
        : null;

      if (storedRemainPaid !== null) {
        return storedRemainPaid;
      }

      return this.getExpectedRemain(attributes);
    },
    getLatestInvoice(invoices = []) {
      if (!Array.isArray(invoices) || invoices.length === 0) {
        return null;
      }

      return [...invoices].sort((a, b) => {
        const aDate = new Date((a.attributes || a).createdAt || 0).getTime();
        const bDate = new Date((b.attributes || b).createdAt || 0).getTime();

        if (aDate !== bDate) {
          return bDate - aDate;
        }

        return (b.id || 0) - (a.id || 0);
      })[0];
    },
    computeOutstandingFromInvoices(invoices = []) {
      if (!Array.isArray(invoices) || invoices.length === 0) {
        return 0;
      }

      let totalOutstanding = 0;

      invoices.forEach((invoice) => {
        totalOutstanding = this.toMoney(
          totalOutstanding + this.getInvoiceRemainingAmount(invoice)
        );
      });

      return totalOutstanding;
    },
    derivePaymentStatus(paid, remainPaid, currentStatus) {
      // Keep review states unchanged to avoid interrupting approval flow.
      if (
        currentStatus === "Waiting Review" ||
        currentStatus === "In Review Progress"
      ) {
        return currentStatus;
      }

      if (remainPaid <= 0) {
        return "Paid";
      }

      if (paid > 0) {
        return "Partial Paid";
      }

      return "Not Paid";
    },
    async reconcileTenantBillsForCurrentRoom() {
      if (!Array.isArray(this.userInvoice) || this.userInvoice.length === 0) {
        return;
      }

      const updateRequests = [];

      this.userInvoice.forEach((invoice) => {
        const attributes = invoice.attributes || {};
        const paid = this.toMoney(attributes.paid);
        const currentRemainPaid = this.toMoney(attributes.remainPaid);
        const expectedRemainPaid = this.getExpectedRemain(attributes);
        const expectedStatus = this.derivePaymentStatus(
          paid,
          expectedRemainPaid,
          attributes.paymentStatus
        );
        const updatePayload = {};

        if (Math.abs(currentRemainPaid - expectedRemainPaid) > 0.009) {
          updatePayload.remainPaid = expectedRemainPaid;
          invoice.attributes.remainPaid = expectedRemainPaid;
        }

        if ((attributes.paymentStatus || "") !== expectedStatus) {
          updatePayload.paymentStatus = expectedStatus;
          invoice.attributes.paymentStatus = expectedStatus;
        }

        if (Object.keys(updatePayload).length > 0) {
          updateRequests.push(
            axios.put(`https://api.resguru.app/api/tenant-bills/${invoice.id}`, {
              data: updatePayload,
            })
          );
        }
      });

      if (updateRequests.length > 0) {
        await Promise.all(updateRequests);
        this.$showNotification(
          "#3A89CB",
          `ซ่อมข้อมูลบิลแล้ว ${updateRequests.length} รายการ`
        );
      }
    },
    rebuildOutstandingFromLocalBills() {
      const latestInvoice = this.getLatestInvoice(this.userInvoice);

      this.userUnpaidInvoice = [];
      this.userPayRemain = 0;

      if (latestInvoice) {
        const latestRemainPaid = this.getInvoiceRemainingAmount(latestInvoice);

        if (latestRemainPaid > 0) {
          this.userUnpaidInvoice = [latestInvoice];
          this.userPayRemain = latestRemainPaid;
        }
      }

      if (this.userUnpaidInvoice.length === 0) {
        this.userPayRemain = this.computeOutstandingFromInvoices(this.userInvoice);
      }
    },
    sumRemainPaid(remainPaidArray) {
      let remainPaid = 0;
      remainPaidArray.forEach((num) => {
        remainPaid += this.toMoney(num.attributes.remainPaid);
      });

      // Format to 2 decimal places
      return parseFloat(remainPaid.toFixed(2));
    },
    updateRoomPriceInvoice(invoiceid, value) {
      axios
        .put("https://api.resguru.app/api/tenant-bills/" + invoiceid, {
          data: {
            roomPrice: value,
          },
        })
        .then((res) => {
          this.$showNotification("#3A89CB", "แก้ไขราคาห้องสำเร็จ");
        })
        .catch((error) => {
          const errorMessage = this.$errMsg(error, 'บันทึกข้อมูล');
          this.$showNotification("danger", errorMessage);
        });
    },
    updateWaterPriceInvoice(invoiceid, value) {
      axios
        .put("https://api.resguru.app/api/tenant-bills/" + invoiceid, {
          data: {
            waterPrice: value,
          },
        })
        .then((res) => {
          this.$showNotification("#3A89CB", "แก้ไขค่าน้ำสำเร็จ");
        })
        .catch((error) => {
          const errorMessage = this.$errMsg(error, 'บันทึกข้อมูล');
          this.$showNotification("danger", errorMessage);
        });
    },
    updateElecPriceInvoice(invoiceid, value) {
      axios
        .put("https://api.resguru.app/api/tenant-bills/" + invoiceid, {
          data: {
            electricPrice: value,
          },
        })
        .then((res) => {
          this.$showNotification("#3A89CB", "แก้ไขค่าไปสำเร็จ");
        })
        .catch((error) => {
          const errorMessage = this.$errMsg(error, 'บันทึกข้อมูล');
          this.$showNotification("danger", errorMessage);
        });
    },
    updateCommunualPriceInvoice(invoiceid, value) {
      axios
        .put("https://api.resguru.app/api/tenant-bills/" + invoiceid, {
          data: {
            communalPrice: value,
          },
        })
        .then((res) => {
          this.$showNotification("#3A89CB", "แก้ไขค่าส่วนกลางสำเร็จ");
        })
        .catch((error) => {
          const errorMessage = this.$errMsg(error, 'บันทึกข้อมูล');
          this.$showNotification("danger", errorMessage);
        });
    },
    updateOtherInvoice(invoiceid, value) {
      axios
        .put("https://api.resguru.app/api/tenant-bills/" + invoiceid, {
          data: {
            otherPrice: value,
          },
        })
        .then((res) => {
          this.$showNotification("#3A89CB", "แก้ไขสำเร็จ"); //other price
        })
        .catch((error) => {
          const errorMessage = this.$errMsg(error, 'บันทึกข้อมูล');
          this.$showNotification("danger", errorMessage);
        });
    },
    getUserProfile() {
      const loading = this.$vs.loading();
      fetch(
        `https://api.resguru.app/api/rooms/${this.$route.query.roomID}?populate=*`
      )
        .then((response) => response.json())
        .then((resp) => {
          this.roomDetail = resp;
          if (resp?.data?.attributes?.user_sign_contract?.data) {
            fetch(
              `https://api.resguru.app/api/user-sign-contracts/${resp.data.attributes.user_sign_contract.data.id}?populate=*`
            ) // get id from user sign contract user_sign_contract
              .then((response) => response.json())
              .then((res) => {
                this.contractProfile = res;
                if (res?.data?.attributes?.users_permissions_user?.data) {
                  fetch(
                    `https://api.resguru.app/api/users/${res.data.attributes.users_permissions_user.data.id}?populate=*`
                  ) // get id from user sign contract user_sign_contract
                    .then((response) => response.json())
                    .then((response) => {
                      this.userProfileImage = response.filePath;
                      this.userProfile = response;
                    })
                    .catch((error) => {
                      const errorMessage = this.$errMsg(error, 'โหลดข้อมูลผู้ใช้');
                      this.$showNotification("danger", errorMessage);
                    });
                }
              })
              .catch((error) => {
                const errorMessage = this.$errMsg(error, 'โหลดข้อมูลสัญญาเช่า');
                this.$showNotification("danger", errorMessage);
              });
          }
        })
        .catch((error) => {
          const errorMessage = this.$errMsg(error, 'โหลดข้อมูลห้องพัก');
          this.$showNotification("danger", errorMessage);
        })
        .finally(() => {
          loading.close();
        });
    },
    selectMenu(menu_option, tr, trID) {
      if (menu_option == "Full Payment") {
        // this.fullPaymentForm.amount = tr.attributes.totaluserPayRemain
        this.fullPaymentForm.amount = this.userPayRemain;
        this.fullPaymentForm.invoiceName = tr.attributes.invoiceNumber;
        // this.fullPaymentForm.invoiceName = generateReNumber()
        this.fullPaymentForm.building = tr.attributes.building.data.id;
        this.fullPaymentForm.userID = tr.attributes.user_sign_contract.data.id;
        this.fullPaymentForm.invoiceID = tr.id;
        this.fullPaymentForm.accountBankName =
          this.userProfile.firstName + " " + this.userProfile.lastName;
        // this.fullPaymentForm.accountBankName = "test"
        this.createFullpayment = true;
      } else if (menu_option == "Partial Payment") {
        const now = new Date();
        this.partialPaymentForm.amount = this.userPayRemain;
        // this.partialPaymentForm.invoiceName = tr.attributes.invoiceNumber
        // this.fullPaymentForm.invoiceName = generateReNumber()

        this.partialPaymentForm.building = tr.attributes.building.data.id;
        this.partialPaymentForm.userID =
          tr.attributes.user_sign_contract.data.id;

        this.partialPaymentForm.invoiceID = tr.id;
        this.partialPaymentForm.accountBankName =
          this.userProfile.firstName + " " + this.userProfile.lastName;
        // Set default date/time to current (user can still change)
        this.partialPaymentForm.paymentDate = now.toISOString().slice(0, 10); // YYYY-MM-DD
        this.partialPaymentForm.paymentTime = now.toTimeString().slice(0, 8);  // HH:mm:ss
        // Set default payment type to Bank transfer
        this.partialPaymentForm.paymentType = "Bank";
        // this.fullPaymentForm.accountBankName = "test"
        this.createPartialPayment = true;
      } else if (menu_option == "Approve Payment") {
  const now = new Date();
  this.approvePaymentForm.paymentDate = this.getCurrentApprovePaymentDate(now);
  this.approvePaymentForm.paymentTime = this.getCurrentApprovePaymentTime(now);

  
  // For tenant evidence payments, we need to find the associated invoice
  // The evidence might not have a direct tenant_bill reference
  
  // First, get the full evidence payment details
  const evidencePayment = this.userEvidencePayment.find(ep => ep.id === trID);
  
  if (evidencePayment) {
    // Set evidence data
    this.approvePaymentForm.amount = evidencePayment.attributes.amount;
    this.approvePaymentForm.fineAmount = 0;
    this.approvePaymentForm.afterFine = evidencePayment.attributes.amount;
    this.approvePaymentForm.evidenceStatus = evidencePayment.attributes.evidenceStatus;
    
    const invoicesForApproval = (
      this.userUnpaidInvoice.length > 0
        ? this.userUnpaidInvoice
        : this.userInvoice.length > 0
          ? [this.getLatestInvoice(this.userInvoice)]
          : []
    ).filter(Boolean);

    const primaryInvoice = this.getLatestInvoice(invoicesForApproval) || invoicesForApproval[0] || null;

    if (primaryInvoice) {
      const paymentSummary = this.buildApprovePaymentSummary(invoicesForApproval);

      this.approvalAllocationBase = {
        roomPrice: paymentSummary.roomPrice,
        waterPrice: paymentSummary.waterPrice,
        electricPrice: paymentSummary.electricPrice,
        communalPrice: paymentSummary.communalPrice,
        otherPrice: paymentSummary.otherPrice,
        carryOverAmount: paymentSummary.carryOverAmount,
      };

      this.approvePaymentForm.roomPrice = paymentSummary.roomPrice.toFixed(2);
      this.approvePaymentForm.waterPrice = paymentSummary.waterPrice.toFixed(2);
      this.approvePaymentForm.electricPrice = paymentSummary.electricPrice.toFixed(2);
      this.approvePaymentForm.communalPrice = paymentSummary.communalPrice.toFixed(2);
      this.approvePaymentForm.otherPrice = paymentSummary.otherPrice.toFixed(2);
      this.approvePaymentForm.carryOverAmount = paymentSummary.carryOverAmount.toFixed(2);
      this.approvePaymentForm.carryOverLabel = paymentSummary.carryOverLabel;
      this.approvePaymentForm.vat = paymentSummary.vat.toFixed(2);
      // Use the actual VAT from the primary invoice: if it's 0, rate is 0%; otherwise use building rate
      this.approvePaymentForm.vatRate = paymentSummary.vat > 0 ? this.getCurrentBuildingVatRate() : 0;
      this.approvePaymentForm.subtotal = (
        paymentSummary.roomPrice +
        paymentSummary.waterPrice +
        paymentSummary.electricPrice +
        paymentSummary.communalPrice +
        paymentSummary.otherPrice +
        paymentSummary.carryOverAmount
      ).toFixed(2);
      this.approvePaymentForm.total = this.userPayRemain
        ? this.userPayRemain.toFixed(2)
        : paymentSummary.total.toFixed(2);
      this.approvePaymentForm.invoiceNumber =
        invoicesForApproval.length > 1
          ? `${primaryInvoice.attributes.invoiceNumber} +${invoicesForApproval.length - 1}`
          : primaryInvoice.attributes.invoiceNumber;
      this.approvePaymentForm.invoiceID = primaryInvoice.id;

      this.applyPaymentAllocationToApprovalForm();
    }
    
    // Set evidence details
    if (evidencePayment.attributes.evidence && evidencePayment.attributes.evidence.data) {
      this.approvePaymentForm.evidenceUrl = 'https://api.resguru.app' + evidencePayment.attributes.evidence.data.attributes.url;
      this.approvePaymentForm.evidenceName = evidencePayment.attributes.evidence.data.attributes.name;
    }
    
    this.approvePaymentForm.building = evidencePayment.attributes.building.data.id;
    this.approvePaymentForm.userID = evidencePayment.attributes.user_sign_contract.data.id;
    this.approvePaymentForm.tenant_evidence_payment = trID; // Store the evidence ID
    this.approvePaymentForm.accountBankName = this.userProfile.firstName + " " + this.userProfile.lastName;
    
    this.createApprovePayment = true;
  } else {
    this.$showNotification("danger", "ไม่พบข้อมูลหลักฐานการชำระเงิน");
  }
      } else if (menu_option == "Old Approve Payment") {
        this.approvePaymentForm.amount = tr.attributes.amount;
        this.approvePaymentForm.fineamount = 0;
        // this.approvePaymentForm.fineamount = tr.attributes.fineamount?tr.attributes.fineamount:0
        // this.partialPaymentForm.invoiceName = tr.attributes.invoiceNumber
        // this.fullPaymentForm.invoiceName = generateReNumber()
        this.approvePaymentForm.afterFine = tr.attributes.amount;
        this.approvePaymentForm.building = tr.attributes.building.data.id;
        this.approvePaymentForm.userID =
          tr.attributes.user_sign_contract.data.id;
        // this.approvePaymentForm.approveBy = ${this.$store.state.userInfo.id}
        this.approvePaymentForm.invoiceID = trID;
        // this.partialPaymentForm.invoiceID = tr.id
        this.approvePaymentForm.accountBankName =
          this.userProfile.firstName + " " + this.userProfile.lastName;
        // this.fullPaymentForm.accountBankName = "test"

        this.createApprovePayment = true;
      }
    },
    createFullPayment() {
      axios
        .post("https://api.resguru.app/api/tenant-evidence-payments", {
          data: {
            tenant_bill: this.fullPaymentForm.invoiceID,
            user_sign_contract: this.fullPaymentForm.userID,
            bankName: this.fullPaymentForm.accountBankName,
            accountBankName: this.fullPaymentForm.bankName,
            amount: this.fullPaymentForm.amount,
            paymentDate:
              this.fullPaymentForm.paymentDate != ""
                ? this.fullPaymentForm.paymentDate
                : new Date(),
            paymentTime:
              this.fullPaymentForm.paymentTime != ""
                ? this.fullPaymentForm.paymentTime
                : new Date().toTimeString,
            building: this.fullPaymentForm.building,
            room: this.$route.query.roomID,
          },
        })
        .then((resp) => {
          axios
            .put(
              "https://api.resguru.app/api/tenant-bills/" +
                this.fullPaymentForm.invoiceID,
              {
                data: {
                  paymentStatus: "Waiting Review",
                },
              }
            )
            .then((res) => {
            })
            .catch((error) => {
              console.error("Error updating invoice status:", error);
            });

          if (this.fileFullPayment.length != 0) {
            let formData = new FormData();
            formData.append("files", this.fileFullPayment);
            formData.append("refId", String(resp.data.data.id));
            formData.append(
              "ref",
              "api::tenant-evidence-payment.tenant-evidence-payment"
            );
            formData.append("field", "evidence");

            axios
              .post("https://api.resguru.app/api/upload", formData, {
                headers: {
                  "Content-Type": "multipart/form-data",
                },
              })
              .then((result) => {
              })
              .catch((error) => {
                console.log(error);
              });
          }
        })
        .catch((error) => {
          const errorMessage = this.$errMsg(error, 'บันทึกข้อมูล');
          this.$showNotification("danger", errorMessage);
        })
        .finally(() => {
          this.getInvoice();
          this.getEvidence();
          this.$showNotification("#3A89CB", "สร้างการชำระเงินสำเร็จ");
        });
      this.createFullpayment = false;
      // alert("Full payment is created")
    },
    updateRoomInvoice(inData) {
      let name = "saveButton" + inData.id;
      document.getElementById(name).setAttribute("disabled", "");

      // Prices only - the backend recomputes subtotal/vat/total/remainPaid
      // from them (keeping carriedDebt and what was already paid). The old
      // payload dropped carriedDebt, ignored paid and cut decimals.
      axios
        .put("https://api.resguru.app/api/tenant-bills/" + inData.id, {
          data: {
            roomPrice: this.toMoney(inData.attributes.roomPrice),
            waterPrice: this.toMoney(inData.attributes.waterPrice),
            electricPrice: this.toMoney(inData.attributes.electricPrice),
            communalPrice: this.toMoney(inData.attributes.communalPrice),
            otherPrice: this.toMoney(inData.attributes.otherPrice),
          },
        })
        .then((res) => {
          this.getInvoice();
          this.$showNotification("#3A89CB", "แก้ไขค่าห้องสำเร็จ");
        })
        .catch((error) => {
          const errorMessage = this.$errMsg(error, 'บันทึกข้อมูล');
          this.$showNotification("danger", errorMessage);
        });
    },
    activeSaveButton(inID) {
      let name = "saveButton" + inID;
      let saveButton = document.getElementById(name);
      saveButton.removeAttribute("disabled");
      // .setAttribute('disabled', '');
      // .removeAttribute('disabled');
    },
    toggleRowDetail(list, id) {
      const index = list.indexOf(id);
      if (index === -1) {
        list.push(id);
      } else {
        list.splice(index, 1);
      }
    },
    isRowExpanded(list, id) {
      return list.includes(id);
    },
    createPartial() {
      // Validate required fields
      if (!this.partialPaymentForm.paymentDate || !this.partialPaymentForm.paymentTime) {
        this.$showNotification("danger", "กรุณาระบุ วันที่ชำระ และ เวลา");
        return;
      }

      
      // Format time to HH:mm:ss if needed
      const paymentTime = this.partialPaymentForm.paymentTime.length === 5 
        ? this.partialPaymentForm.paymentTime + ":00" 
        : this.partialPaymentForm.paymentTime;

      axios
        .post("https://api.resguru.app/api/tenant-evidence-payments", {
          data: {
            tenant_bill: this.partialPaymentForm.invoiceID,
            user_sign_contract: this.partialPaymentForm.userID,
            bankName: this.partialPaymentForm.accountBankName,
            accountBankName: this.partialPaymentForm.bankName,
            amount: this.partialPaymentForm.amount,
            paymentDate: this.partialPaymentForm.paymentDate,
            paymentTime: paymentTime,
            building: this.partialPaymentForm.building,
            fine: this.partialPaymentForm.fineamount,
            room: this.$route.query.roomID,
            paymentType: this.partialPaymentForm.paymentType,
          },
        })
        .then((resp) => {

          for (let j = 0; j < this.userUnpaidInvoice.length; j++) {
            axios
              .put(
                "https://api.resguru.app/api/tenant-bills/" +
                  this.userUnpaidInvoice[j].id,
                {
                  data: {
                    paymentStatus: "Waiting Review",
                  },
                }
              )
              .then((res) => {
              })
              .catch((error) => {
                console.error("Error updating invoice status:", error);
              })
              .finally(() => {
                this.getInvoice();
              });
          }
          if (this.filePartialPayment.length != 0) {
            let formData = new FormData();
            formData.append("files", this.filePartialPayment);
            formData.append("refId", String(resp.data.data.id));
            formData.append(
              "ref",
              "api::tenant-evidence-payment.tenant-evidence-payment"
            );
            formData.append("field", "evidence");

            axios
              .post("https://api.resguru.app/api/upload", formData, {
                headers: {
                  "Content-Type": "multipart/form-data",
                },
              })
              .then((result) => {
              })
              .catch((error) => {
                console.log(error);
              });
          }
        })
        .finally(() => {
          this.getInvoice();
          this.getEvidence();
          this.$showNotification("#3A89CB", "สร้างการชำระเงินสำเร็จ");
        })
        .catch((error) => {
          const errorMessage = this.$errMsg(error, 'บันทึกข้อมูล');
          this.$showNotification("danger", errorMessage);
        });
      this.createPartialPayment = false;
      // alert("Partial payment is created")
    },
    getInvoice() {
      //rewrite to get room id and return all of invoice of that room
      const loading = this.$vs.loading();
      fetch(
        `https://api.resguru.app/api/tenant-bills?filters[room][id][$eq]=${this.$route.query.roomID}&populate=*&sort[0]=id:desc&publicationState=preview`
      )
        .then((response) => response.json())
        .then(async (resp) => {
          this.userInvoice = resp.data || [];

          await this.reconcileTenantBillsForCurrentRoom();
          this.rebuildOutstandingFromLocalBills();
        })
        .catch((error) => {
          const errorMessage = this.$errMsg(error, 'โหลดข้อมูลใบแจ้งหนี้');
          this.$showNotification("danger", errorMessage);
        })
        .finally(() => {
          loading.close();
        });
    },
    getReceipt() {
      const loading = this.$vs.loading();
      fetch(
        `https://api.resguru.app/api/tenant-receipts?filters[room][id][$eq]=${this.$route.query.roomID}&populate=deep,3&sort[0]=id:desc`
      )
        .then((response) => response.json())
        .then((resp) => {
          this.userReceipt = resp.data;
        })
        .catch((error) => {
          const errorMessage = this.$errMsg(error, 'โหลดข้อมูลใบเสร็จ');
          this.$showNotification("danger", errorMessage);
        })
        .finally(() => {
          loading.close();
        });
    },
    getEvidence() {
      const loading = this.$vs.loading();
      fetch(
        `https://api.resguru.app/api/tenant-evidence-payments?filters[room][id][$eq]=${this.$route.query.roomID}&populate=*&sort[0]=id:desc`
      )
        // fetch(`https://api.resguru.app/api/tenant-evidence-payments`)
        .then((response) => response.json())
        .then((resp) => {
          this.userEvidencePayment = resp.data;
        })
        .catch((error) => {
          const errorMessage = this.$errMsg(error, 'โหลดข้อมูลหลักฐานการชำระเงิน');
          this.$showNotification("danger", errorMessage);
        })
        .finally(() => {
          loading.close();
        });
    },
    // generateReNumber() {
    //     var result = this.userBuilding.attributes.receiptNumber
    //     if (result != null || result != 0) {
    //         result = "RE-" + new Date().getFullYear().toString().substr(-2) + (result + 1).toString().padStart(5, '0')
    //     } else {
    //         result = "RE-" + new Date().getFullYear().toString().substr(-2) + "00001"
    //     }
    //     // console.log("generateReNumber", result)
    //     return result
    // },
    setUploadFilePayment() {
      this.filePartialPayment = this.$refs.PartialPayment.files[0];
    },
    setUploadFileFullPayment() {
      this.fileFullPayment = this.$refs.FullPayment.files[0];
    },
    // updateEvidence() {
    //     axios.put('https://api.resguru.app/api/tenant-evidence-payments/' + this.userEvidencePayment[0].id, {
    //         data: {
    //             evidenceStatus: "Approve"
    //         }
    //     })
    //         .then((res) => {
    //             this.$showNotification('#3A89CB', 'Update Evidence Success')
    //         }
    //         )
    //         .catch(error => {
    //             const errorMessage = this.$errMsg(error, 'บันทึกข้อมูล');
    //             this.$showNotification('danger', errorMessage);
    //         })

    // },
    // updateInvoice(remain) {
    //     var invoiceData = {
    //             paymentStatus: "Paid",
    //             paid: this.userEvidencePayment[0].attributes.amount
    //         }
    //     if (remain) {
    //         invoiceData.remainPaid = remain
    //     }
    //     axios.put('https://api.resguru.app/api/tenant-bills/' + this.userInvoice[0].id, {
    //         data: invoiceData
    //     })
    //         .then((res) => {
    //             this.$showNotification('#3A89CB', 'Update Invoice Success')
    //         }
    //         )
    //         .catch(error => {
    //             const errorMessage = this.$errMsg(error, 'บันทึกข้อมูล');
    //             this.$showNotification('danger', errorMessage);
    //         })
    //     // console.log(this.userInvoice[0])
    //     // console.log(this.userEvidencePayment[0].attributes)
    // },
    // createReceipt(data) {
    //     this.userUnpaidInvoice.slice().reverse().forEach(element => {
    //         if(data.attributes.amount >= element.remainPaid){
    //             var finalRemain =  element.remainPaid - data.attributes.amount
    //             axios.post('https://api.resguru.app/api' + '/tenant-receipts', {
    //                 data: {
    //                     // date_execute: this.date_execute,
    //                     tenant_bill: data.attributes.tenant_bill.data.id,
    //                     user_sign_contract: data.attributes.user_sign_contract.data.id,
    //                     paidAmount: element.total,
    //                     // receiptNumber: "RE_" + data.attributes.tenant_bill.data.attributes.invoiceNumber,
    //                     //roomPrice: data.attributes.roomPrice,
    //                     //waterPrice: data.attributes.waterPrice,
    //                     //electricPrice: data.attributes.electricPrice,
    //                     //communalPrice: data.attributes.communalPrice,
    //                     //otherPrice: data.attributes.otherPrice,
    //                     //subTotal: data.attributes.subtotal,
    //                     //vat: data.attributes.vat,
    //                     //total: data.attributes.total,
    //                     building: data.attributes.building.data.id,
    //                     tenant_evidence_payment: data.id,
    //                     tenant_evidence_payment_receipt: data.id
    //                 }
    //             })
    //             .then((res) => {
    //                 this.$showNotification('#3A89CB', 'Create Receipt Success')
    //                 updateEvidence()
    //                 updateInvoice(finalRemain > 0 ? finalRemain : 0 )
    //             }
    //             )
    //             .catch(error => {
    //                 const errorMessage = this.$errMsg(error, 'บันทึกข้อมูล');
    //                 this.$showNotification('danger', errorMessage);
    //             })
    //             .finally(() => {
    //                 this.getInvoice();
    //                 this.getReceipt();
    //                 this.getEvidence();
    //             })
    //         } else {
    //             var finalRemain =  element.remainPaid - data.attributes.amount
    //             updateInvoice(finalRemain > 0 ? finalRemain : 0 )
    //             this.getInvoice();
    //             this.getReceipt();
    //             this.getEvidence();

    //         }
    //     });
    // },
createReceipt() {
  let today = new Date();
  const paidDate = this.normalizeApprovePaymentDate(this.approvePaymentForm.paymentDate);
  const paidTime = this.approvePaymentForm.paymentTime || this.getCurrentApprovePaymentTime(today);
  const fineAmount = Number(this.approvePaymentForm.fineAmount) || 0;
  const paidAmount = Number(this.approvePaymentForm.afterFine || this.approvePaymentForm.amount || 0);
      
  axios
    .post("https://api.resguru.app/api/approvePayment", {
      data: {
        buildingid: this.approvePaymentForm.building,
        roomid: parseInt(this.$route.query.roomID),
        month: today.getMonth() + 1,
        year: today.getFullYear(),
        evidenceid: this.approvePaymentForm.tenant_evidence_payment,
        paidAmount,
        fineAmount,
        paidDate: paidDate,
        paidTime: paidTime
      }
    }, authHeaders())
    .then((res) => {
      this.$showNotification("#3A89CB", "อนุมัติการชำระเงินสำเร็จ");
      this.generateReceiptPDFs(res.data?.receiptIds || []);
    })
    .catch((error) => {
      const errorMessage = this.$errMsg(error, 'บันทึกข้อมูล');
      this.$showNotification("danger", errorMessage);
    })
    .finally(() => {
      this.getInvoice();
      this.getReceipt();
      this.getEvidence();
      this.createApprovePayment = false;
    });
},
    // Renders + uploads the receipt PDF for each newly-created tenant-receipt
    // right after approval, with no owner action needed - this is what makes
    // the receipt available for the tenant app to fetch afterward.
    generateReceiptPDFs(receiptIds) {
      receiptIds.forEach((id) => {
        axios
          .get(`https://api.resguru.app/api/tenant-receipts/${id}?populate=deep,3`)
          .then((resp) => {
            const receipt = resp.data?.data;
            if (receipt) {
              this.$refs.childComponentPDFReceipt.generatePDF(receipt, true, id);
            }
          })
          .catch((error) => {
            console.error('Failed to generate receipt PDF', id, error);
          });
      });
    },
    OldcreateReceipt() {
      //ส่งบอกว่า evident ถูก approve แล้ว หลังบ้านจะไป update invoice, current evident, และ สร้าง reciept ตามจำเป็น
      let today = new Date();
      axios
        .post("https://api.resguru.app/api" + "/approvePayment", {
          data: {
            year: today.getFullYear(),
            month: today.getMonth() + 1,
            evidenceid: this.approvePaymentForm.invoiceID,
            paidAmount: this.approvePaymentForm.amount,
            buildingid: this.approvePaymentForm.building,
            roomid: parseInt(this.$route.query.roomID),
            paidDate: today,
            fine: this.approvePaymentForm.fineamount,
            // approveBy: data.attributes.toUser.data?.attributes.firstName
          },
        })
        .then((res) => {
          this.$showNotification("#3A89CB", "อนุมัติการชำระเงินสำเร็จ");
        })
        .catch((error) => {
          const errorMessage = this.$errMsg(error, 'บันทึกข้อมูล');
          this.$showNotification("danger", errorMessage);
        })
        .finally(() => {
          this.getInvoice();
          this.getReceipt();
          this.getEvidence();
        });
      this.createApprovePayment = false;
    },

    //cal afterFine in approve popup
    OldcalAfterFine() {
      let result;
      result =
        this.approvePaymentForm.amount - this.approvePaymentForm.fineamount;
      document.getElementById("afterFine").value = result;
    },
    applyPaymentAllocationToApprovalForm() {
      if (!this.approvalAllocationBase) {
        return;
      }

      // Each field shows how much of THIS payment is being applied to that
      // line item (so the columns sum to the payment amount), not how much
      // of the original charge is left unpaid - deducted in order: old
      // debt first, then room, water, electric, then everything else.
      const availablePayment = Number(this.approvePaymentForm.afterFine || this.approvePaymentForm.amount || 0);
      let remainingPayment = Math.max(0, availablePayment);

      const allocationOrder = [
        "carryOverAmount",
        "roomPrice",
        "waterPrice",
        "electricPrice",
        "communalPrice",
        "otherPrice",
      ];

      const appliedAmounts = {};
      allocationOrder.forEach((key) => {
        const originalAmount = Number(this.approvalAllocationBase[key] || 0);
        const appliedAmount = Math.min(remainingPayment, originalAmount);
        appliedAmounts[key] = appliedAmount;
        remainingPayment = Math.max(0, remainingPayment - appliedAmount);
      });

      // If the payment is more than everything owed, put the leftover into
      // otherPrice (the last bucket in the deduction order) so the total
      // shown always matches the amount actually paid.
      if (remainingPayment > 0) {
        appliedAmounts.otherPrice += remainingPayment;
      }

      allocationOrder.forEach((key) => {
        this.approvePaymentForm[key] = appliedAmounts[key].toFixed(2);
      });

      this.recalculateVat();
    },
    calAfterFine() {
      const fineAmount = parseFloat(this.approvePaymentForm.fineAmount) || 0;
      const amount = parseFloat(this.approvePaymentForm.amount) || 0;
      const afterFine = Math.max(0, amount - fineAmount);
      
      this.approvePaymentForm.afterFine = Number(afterFine.toFixed(2));
      this.applyPaymentAllocationToApprovalForm();
    },
    
    getNextReceiptNumber(baseNumber) {
      baseNumber = String(baseNumber);

      // Match if it already ends with "-number" after another "-number" block
      const match = baseNumber.match(/-\d+-\d+$/);

      if (match) {
        // Example: IV25-00002-1 → increment last digit only
        return baseNumber.replace(/-(\d+)$/, (_, n) => `-${parseInt(n, 10) + 1}`);
      } else {
        // Example: IV25-00002 → append -1
        return `${baseNumber}-1`;
      }
    },

    getCurrentBuildingVatRate() {
      const buildingInfo = this.$store.state.buildingInfo;
      const activeBuildingId = this.$store.state.building;

      if (Array.isArray(buildingInfo)) {
        const activeBuilding =
          buildingInfo.find((building) => building.id === activeBuildingId) ||
          buildingInfo[0];

        return getVatRate(activeBuilding?.attributes);
      }

      return getVatRate(buildingInfo?.attributes);
    },

    formatCarryOverLabel(dateString) {
      if (!dateString) {
        return "ค่าใช้จ่ายค้างจากเดือนก่อนหน้า";
      }

      const date = new Date(dateString);
      if (Number.isNaN(date.getTime())) {
        return "ค่าใช้จ่ายค้างจากเดือนก่อนหน้า";
      }

      const formattedMonth = new Intl.DateTimeFormat("th-TH", {
        month: "long",
        year: "numeric",
      }).format(date);

      return `ค่าใช้จ่ายค้างจากเดือน${formattedMonth}`;
    },

    getPreviousMonthThaiName(dateString) {
      if (!dateString) {
        return "";
      }

      const date = new Date(dateString);
      if (Number.isNaN(date.getTime())) {
        return "";
      }

      date.setMonth(date.getMonth() - 1);

      const thaiMonths = [
        "มกราคม", "กุมภาพันธ์", "มีนาคม", "เมษายน",
        "พฤษภาคม", "มิถุนายน", "กรกฎาคม", "สิงหาคม",
        "กันยายน", "ตุลาคม", "พฤศจิกายน", "ธันวาคม"
      ];

      return thaiMonths[date.getMonth()] || "";
    },

    formatPreviousMonthCarryOverLabel(dateString) {
      const previousMonthName = this.getPreviousMonthThaiName(dateString);

      if (!previousMonthName) {
        return "ยอดค้างจากเดือนก่อนหน้า";
      }

      return `ยอดค้างจากเดือน${previousMonthName}`;
    },

    buildApprovePaymentSummary(invoices) {
      const latestInvoice = this.getLatestInvoice(invoices);
      const primaryInvoice = latestInvoice || invoices[0];
      const primaryAttributes = primaryInvoice?.attributes || primaryInvoice || {};
      // carriedDebt is the actual old-debt amount rolled forward onto this
      // bill by the backend's carry-forward logic at bill-creation time -
      // read it directly instead of back-deriving it from
      // totalOutstanding - currentInvoiceAmount, which double-counted VAT
      // (totalOutstanding already includes vat, currentInvoiceAmount doesn't)
      // and produced a wrong/zero carryOverAmount whenever the two didn't
      // line up.
      // Net out amounts already recorded against this bill by earlier
      // partial payments (tracked cumulatively by the backend in
      // paidRoom/paidWater/paidElectric/paidCommunalPrice/paidOtherPrice)
      // so the breakdown shown here is what's still owed per category,
      // not the bill's original full charge.
      const roomPrice = Math.max(0, (parseFloat(primaryAttributes.roomPrice) || 0) - (parseFloat(primaryAttributes.paidRoom) || 0));
      const waterPrice = Math.max(0, (parseFloat(primaryAttributes.waterPrice) || 0) - (parseFloat(primaryAttributes.paidWater) || 0));
      const electricPrice = Math.max(0, (parseFloat(primaryAttributes.electricPrice) || 0) - (parseFloat(primaryAttributes.paidElectric) || 0));
      const communalPrice = Math.max(0, (parseFloat(primaryAttributes.communalPrice) || 0) - (parseFloat(primaryAttributes.paidCommunalPrice) || 0));
      const otherPrice = Math.max(0, (parseFloat(primaryAttributes.otherPrice) || 0) - (parseFloat(primaryAttributes.paidOtherPrice) || 0));
      const vat = parseFloat(primaryAttributes.vat) || 0;
      const carryOverAmount = Math.max(0, parseFloat(primaryAttributes.carriedDebt) || 0);
      return {
        roomPrice,
        waterPrice,
        electricPrice,
        communalPrice,
        otherPrice,
        carryOverAmount,
        carryOverLabel: this.formatPreviousMonthCarryOverLabel(primaryAttributes.createdAt),
        vat,
        total: roomPrice + waterPrice + electricPrice + communalPrice + otherPrice + vat + carryOverAmount,
      };
    },

    recalculateVat() {
    // Get the VAT rate (0 or 7)
      const vatRate = parseFloat(this.approvePaymentForm.vatRate);
      
      const roomPrice = parseFloat(this.approvePaymentForm.roomPrice) || 0;
      const waterPrice = parseFloat(this.approvePaymentForm.waterPrice) || 0;
      const electricPrice = parseFloat(this.approvePaymentForm.electricPrice) || 0;
      const communalPrice = parseFloat(this.approvePaymentForm.communalPrice) || 0;
      const otherPrice = parseFloat(this.approvePaymentForm.otherPrice) || 0;
      const carryOverAmount = parseFloat(this.approvePaymentForm.carryOverAmount) || 0;
      
      // Calculate subtotal without VAT
      const subtotalNoRoom = waterPrice + electricPrice + communalPrice + otherPrice + carryOverAmount;
      const subtotal = roomPrice + subtotalNoRoom;
      
      if (vatRate === 0) {
        // If VAT is 0%, set all VAT values to 0
        this.approvePaymentForm.vat = 0.00.toFixed(2);
        this.approvePaymentForm.waterPriceVat = 0.00.toFixed(2);
        this.approvePaymentForm.electricPriceVat = 0.00.toFixed(2);
        this.approvePaymentForm.communalPriceVat = 0.00.toFixed(2);
        this.approvePaymentForm.subtotal = subtotal.toFixed(2);
        this.approvePaymentForm.total = subtotal.toFixed(2);
      } else {
        // If VAT is 7%, calculate VAT for each component except room price
        const waterPriceVat = waterPrice * (vatRate / 100);
        const electricPriceVat = electricPrice * (vatRate / 100);
        const communalPriceVat = communalPrice * (vatRate / 100);
        
        // Total VAT amount
        const totalVat = waterPriceVat + electricPriceVat + communalPriceVat;
        
        // Update VAT values
        this.approvePaymentForm.waterPriceVat = waterPriceVat.toFixed(2);
        this.approvePaymentForm.electricPriceVat = electricPriceVat.toFixed(2);
        this.approvePaymentForm.communalPriceVat = communalPriceVat.toFixed(2);
        this.approvePaymentForm.vat = totalVat.toFixed(2);
        
        // Update subtotal and total
        this.approvePaymentForm.subtotal = (subtotal - totalVat).toFixed(2);
        this.approvePaymentForm.total = (subtotalNoRoom + totalVat + roomPrice).toFixed(2);
      }
    },
    
    // Modify the existing calculateTotal method
    calculateTotal() {
      const roomPrice = parseFloat(this.approvePaymentForm.roomPrice) || 0;
      const waterPrice = parseFloat(this.approvePaymentForm.waterPrice) || 0;
      const electricPrice = parseFloat(this.approvePaymentForm.electricPrice) || 0;
      const communalPrice = parseFloat(this.approvePaymentForm.communalPrice) || 0;
      const otherPrice = parseFloat(this.approvePaymentForm.otherPrice) || 0;
      const carryOverAmount = parseFloat(this.approvePaymentForm.carryOverAmount) || 0;
      
      // Calculate subtotal
      const subtotal = roomPrice + waterPrice + electricPrice + communalPrice + otherPrice + carryOverAmount;
      const subtotalNoRoom = waterPrice + electricPrice + communalPrice + otherPrice + carryOverAmount;
      
      // Get VAT rate
      const vatRate = parseFloat(this.approvePaymentForm.vatRate);
      
      if (vatRate === 0) {
        this.approvePaymentForm.subtotal = subtotal.toFixed(2);
        // If VAT is 0%, just set total = subtotal
        this.approvePaymentForm.vat = 0.00.toFixed(2);
        this.approvePaymentForm.total = subtotal.toFixed(2);
        this.approvePaymentForm.waterPriceVat = 0.00.toFixed(2);
        this.approvePaymentForm.electricPriceVat = 0.00.toFixed(2);
        this.approvePaymentForm.communalPriceVat = 0.00.toFixed(2);
      } else {
        // If VAT is 7%, calculate VAT amount
        const waterPriceVat = waterPrice * (vatRate / 100);
        const electricPriceVat = electricPrice * (vatRate / 100);
        const communalPriceVat = communalPrice * (vatRate / 100);
        const vatAmount = waterPriceVat + electricPriceVat + communalPriceVat;
        
        this.approvePaymentForm.vat = vatAmount.toFixed(2);
        this.approvePaymentForm.total = (subtotalNoRoom + vatAmount + roomPrice).toFixed(2);
        this.approvePaymentForm.waterPriceVat = waterPriceVat.toFixed(2);
        this.approvePaymentForm.electricPriceVat = electricPriceVat.toFixed(2);
        this.approvePaymentForm.communalPriceVat = communalPriceVat.toFixed(2);
        this.approvePaymentForm.subtotal = (subtotal - vatAmount).toFixed(2);
      }
    },
    // Add a new method to your component
    formatDecimal(value) {
      const num = parseFloat(value);
      return num ? num.toFixed(2) : '0.00';
    },


    // createReceipt(currentEvident) { //ส่งบอกว่า evident ถูก approve แล้ว หลังบ้านจะไป update invoice, current evident, และ สร้าง reciept ตามจำเป็น
    //     let today = new Date()
    //     axios.post('https://api.resguru.app/api' + '/approvePayment', {
    //         data:{
    //             year: today.getFullYear(),
    //             month: today.getMonth()+1,
    //             evidenceid: currentEvident.id,
    //             paidAmount: currentEvident.attributes.amount,
    //             buildingid: currentEvident.attributes.building.data.id,
    //             roomid: parseInt(this.$route.query.roomID),
    //             paidDate: currentEvident.attributes.paymentDate? currentEvident.attributes.paymentDate : today,

    //         }
    //     })
    //     .then((res) => {
    //         this.$showNotification('#3A89CB', 'Approve Evident Success')
    //     }
    //     )
    //     .catch(error => {
    //         const errorMessage = this.$errMsg(error, 'บันทึกข้อมูล');
    //         this.$showNotification('danger', errorMessage);
    //     })
    //     .finally(() => {
    //         this.getInvoice();
    //         this.getReceipt();
    //         this.getEvidence();
    //     })
    // },
    getLinkedInvoiceIdsFromEvidence(currentEvident) {
      const directLinkedInvoiceId = currentEvident?.attributes?.tenant_bill?.data?.id;

      if (directLinkedInvoiceId) {
        return [directLinkedInvoiceId];
      }

      const legacyLinkedInvoiceId = currentEvident?.attributes?.tenant_bill?.id;
      if (legacyLinkedInvoiceId) {
        return [legacyLinkedInvoiceId];
      }

      return [];
    },

    async restoreInvoiceStatusesAfterReject(currentEvident) {
      const linkedInvoiceIds = this.getLinkedInvoiceIdsFromEvidence(currentEvident);

      const invoicesInReview = this.userInvoice.filter((invoice) => {
        const isWaitingReview = invoice.attributes?.paymentStatus === "Waiting Review";

        if (!isWaitingReview) {
          return false;
        }

        // Prefer only invoices explicitly linked to this evidence payment.
        // Fallback to room-level waiting invoices when relation is missing.
        if (linkedInvoiceIds.length > 0) {
          return linkedInvoiceIds.includes(invoice.id);
        }

        return true;
      });

      if (invoicesInReview.length === 0) {
        return;
      }

      await Promise.all(
        invoicesInReview.map((invoice) => {
          const attributes = invoice.attributes || {};
          const remainPaid = parseFloat(attributes.remainPaid) || 0;
          const paid = parseFloat(attributes.paid) || 0;
          const rollbackStatus = paid > 0 && remainPaid > 0 ? "Partial Paid" : "Not Paid";

          return axios.put(
            `https://api.resguru.app/api/tenant-bills/${invoice.id}`,
            {
              data: {
                paymentStatus: rollbackStatus,
              },
            }
          );
        })
      );
    },

    cancelPayment(currentEvident) {
      //ส่งบอกว่า evident ถูก approve แล้ว หลังบ้านจะไป update invoice, current evident, และ สร้าง reciept ตามจำเป็น
      axios
        .put(
          "https://api.resguru.app/api/tenant-evidence-payments/" +
            currentEvident.id,
          {
            data: {
              evidenceStatus: "Reject",
            },
          }
        )
        .then(async () => {
          await this.restoreInvoiceStatusesAfterReject(currentEvident);
          this.$showNotification("#3A89CB", "ยกเลิกการชำระเงินสำเร็จ");
        })
        .catch((error) => {
          const errorMessage = this.$errMsg(error, 'บันทึกข้อมูล');
          this.$showNotification("danger", errorMessage);
        })
        .finally(() => {
          this.getInvoice();
          this.getReceipt();
          this.getEvidence();
        });
    },

    async PDFPrintReceipt(tr) {
      this.$showNotification("#3A89CB", "กำลังสร้าง PDF หากไม่มีไฟล์เปิดขึ้นมา กรุณาตรวจสอบว่าเบราว์เซอร์บล็อก Popup อยู่หรือไม่");
      this.$refs.childComponentPDFReceipt.generatePDF(tr);
    },
    // Method for the "Download Invoice" button at the top of the page.
    // Reuses PDFPrintInvoice's flattening instead of passing the raw
    // Strapi {id, attributes} shape straight through - PDFgenerator reads
    // fields like tenant_bills[0].roomPrice directly, not .attributes.roomPrice.
    async PDFPrint(mode = 'download') {
      if (this.selected.length > 0) {
        this.PDFPrintInvoice(this.selected[0], mode);
      } else {
        this.$showNotification("warning", "กรุณาเลือกรายการที่ต้องการพิมพ์");
      }
    },
    async PDFPrintInvoice(invoice, mode = 'download') {
      if (!invoice || !invoice.attributes) {
        this.$showNotification("warning", "ข้อมูลใบแจ้งหนี้ไม่ครบถ้วน");
        return;
      }

      const contractAttrs = this.contractProfile?.data?.attributes || {};
      const tenantUser = contractAttrs.users_permissions_user?.data?.attributes || {};

      const data = {
        RoomNumber: this.roomDetail?.data?.attributes?.RoomNumber,
        user_sign_contract: {
          startWater: contractAttrs.startWater || 0,
          startElectric: contractAttrs.startElectric || 0,
          users_permissions_user: {
            firstName: tenantUser.firstName || "",
            lastName: tenantUser.lastName || "",
            contactAddress: tenantUser.contactAddress || "",
            phone: tenantUser.phone || "",
          },
        },
        tenant_bills: [{
          id: invoice.id,
          invoiceNumber: invoice.attributes.invoiceNumber || "N/A",
          roomPrice: parseFloat(invoice.attributes.roomPrice) || 0,
          waterPrice: parseFloat(invoice.attributes.waterPrice) || 0,
          electricPrice: parseFloat(invoice.attributes.electricPrice) || 0,
          communalPrice: parseFloat(invoice.attributes.communalPrice) || 0,
          otherPrice: parseFloat(invoice.attributes.otherPrice) || 0,
          vat: parseFloat(invoice.attributes.vat) || 0,
          total: parseFloat(invoice.attributes.total) || 0,
          subtotal: parseFloat(invoice.attributes.subtotal) || 0,
          createdAt: invoice.attributes.createdAt || new Date().toISOString(),
          lastWaterUnit: invoice.attributes.lastWaterUnit || 0,
          meterUnit: invoice.attributes.meterUnit || 0,
          waterUnit: invoice.attributes.waterUnit || 0,
          usageWater: invoice.attributes.usageWater || 0,
          lastElectricUnit: invoice.attributes.lastElectricUnit || 0,
          lastElecUnit: invoice.attributes.lastElecUnit || 0,
          electicUnit: invoice.attributes.electicUnit || 0,
          electricUnit: invoice.attributes.electricUnit || 0,
          usageElectric: invoice.attributes.usageElectric || 0,
          usageMeter: invoice.attributes.usageMeter || 0,
          paymentStatus: invoice.attributes.paymentStatus || "ยังไม่ชำระ",
          remainPaid: parseFloat(invoice.attributes.remainPaid) || 0,
          carriedDebt: parseFloat(invoice.attributes.carriedDebt) || 0,
          creditApplied: parseFloat(invoice.attributes.creditApplied) || 0,
          pastRoomPrice: parseFloat(invoice.attributes.pastRoomPrice) || 0,
          pastWaterPrice: parseFloat(invoice.attributes.pastWaterPrice) || 0,
          pastElectricPrice: parseFloat(invoice.attributes.pastElectricPrice) || 0,
          pastCommunalPrice: parseFloat(invoice.attributes.pastCommunalPrice) || 0,
          pastOtherPrice: parseFloat(invoice.attributes.pastOtherPrice) || 0
        }],
        room_type: this.roomDetail?.data?.attributes?.room_type?.data
      };
      
      this.$showNotification(
        "#3A89CB",
        mode === 'preview'
          ? "กำลังสร้าง PDF หากไม่มีไฟล์เปิดขึ้นมา กรุณาตรวจสอบว่าเบราว์เซอร์บล็อก Popup อยู่หรือไม่"
          : "กำลังสร้าง PDF และดาวน์โหลดไฟล์"
      );
      this.$refs.childComponentPDF.generatePDF(data, mode);
    }
    // Method for the download button in each table row
    // async PDFPrintInvoice(invoice) {
    //   // Check if invoice has actual data
    //   console.log("Invoice room price:", invoice.attributes.roomPrice);
    //   console.log("Invoice total:", invoice.attributes.total);
      
    //   if (!invoice.attributes.roomPrice && !invoice.attributes.total) {
    //     this.$showNotification("warning", "ข้อมูลใบแจ้งหนี้ไม่ครบถ้วน กรุณาตรวจสอบ");
    //     return;
    //   }
      
    //   // Proceed with PDF generation if data exists
    //   const data = {
    //     RoomNumber: this.roomDetail.data.attributes.RoomNumber,
    //     user_sign_contract: this.contractProfile.data,
    //     tenant_bills: [invoice],
    //     room_type: this.roomDetail.data.attributes.room_type.data
    //   };
      
    //   this.$refs.childComponentPDF.generatePDF(data);
    // }
  },
};
</script>
